export default {
    id: "ταυτότητα",
    dashboard: "Ταμπλό",
    warning: "Προειδοποίηση",
    users: "Χρήστες",
    farms: "Αγροκτήματα",
    animals: "Των ζώων",
    action: "Δράση",
    actionList: "Λίστα ενεργειών",
    drugInventory: "Απογραφή φαρμάκων",
    inseminatorStatistics: "Στατιστικά σπερματέγχυσης",
    organizationNTR: "Οργανισμός NTR",
    genotypePerformance: "Απόδοση Γονότυπου",
    semenAutomation: "Αυτοματισμός σπέρματος",
    activityLogs: "Αρχείο καταγραφής δραστηριότητας",
    username: "Ονομα χρήστη",
    title: "Τίτλος",
    deactivated: "Απενεργοποιήθηκε",
    name: "Ονομα",
    email: "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
    emailAddress: "Διεύθυνση ηλεκτρονικού ταχυδρομείου",
    mobileNum: "Αριθμός κινητού",
    emailOrMobile: "Email/Κινητό",
    role: "Ρόλος",
    roles: "Ρόλοι",
    department: "Τμήμα",
    status: "Κατάσταση",
    pages: "Σελίδες",
    departments: "Τμήματα",
    password: "Κωδικός πρόσβασης",
    cancel: "Ματαίωση",
    submit: "υποβάλλουν",
    error: "λάθος",
    success: "επιτυχία",
    Browse: "Ξεφυλλίζω",
    orDropYourFileCsvXlsXlsxHere: "ή αποθέστε το αρχείο σας (CSV, XLS, XLSx) εδώ",
    search: "Αναζήτηση",
    apply: "Ισχύουν",
    select: "Επιλέγω",
    previous: "Προηγούμενος",
    mandatory: "Επιτακτικός",
    dropYourFileHere: "ή αποθέστε το αρχείο σας (CSV, XLS, XLSx, PDF, Docx, PNG, JPEG) εδώ",
    restoreDefault: "Επαναφορά προεπιλογής",
    pending: "εκκρεμής",
    completed: "Ολοκληρώθηκε το",
    remove: "Αφαιρώ",
    update: "Εκσυγχρονίζω",
    removeFile: "Κατάργηση αρχείου",
    uploadFile: "Ανέβασμα αρχείου",
    pleaseChoosePreferedLanguage: "Επιλέξτε τη γλώσσα που προτιμάτε",
    edit: "Επεξεργασία",
    activate: "Δραστηριοποιώ",
    deactivate: "Απενεργοποίηση",
    recievedOrders: "Λήφθηκαν παραγγελίες",
    chartRepresentation: "Αναπαράσταση γραφήματος",
    nameIsRequired: "Το όνομα απαιτείται",
    export: "Εξαγωγή",
    noFilesAvailable: "ΔΕΝ ΥΠΑΡΧΟΥΝ ΔΙΑΘΕΣΙΜΑ ΑΡΧΕΙΑ",
    selectDepartmentToshowRoles: "Επιλέξτε ένα τμήμα για εμφάνιση ρόλων",
    selectDepartmentWithActiveRoles: "Επιλέξτε ένα τμήμα με ενεργούς ρόλους",
    nameCanContainOnlyAlphabets: "Το όνομα μπορεί να περιέχει μόνο αλφάβητα",
    nameMustBeLessThan15Chars: "Το όνομα πρέπει να είναι λιγότερο από 30 χαρακτήρες",
    emailRequired: "Απαιτείται email",
    invalidEmailFormat: "Μη έγκυρη μορφή email",
    mobNumReq: "Απαιτείται αριθμός κινητού",
    invalidMobFormat: "Μη έγκυρη μορφή αριθμού κινητού τηλεφώνου.",
    passwordRequired: "Απαιτείται κωδικός",
    departmentReq: "Απαιτείται τμήμα",
    roleReq: "Απαιτείται ρόλος",
    unableToUpdate: "Δεν είναι δυνατή η ενημέρωση",
    orignalName: "Αρχικό Όνομα",
    uploadedDate: "Ημερομηνία μεταφόρτωσης",
    fileName: "Ονομα αρχείου",
    importNum: "Αριθμός εισαγωγής",
    languagePreferences: "προτίμηση γλώσσας",
    pleaseTryAgainAfterSometime: "Παρακαλώ δοκιμάστε μετά από κάποιο χρονικό διάστημα",
    noChanges: "Χωρίς αλλαγές",
    nothingchanged: "Τίποτα δεν άλλαξε",
    pleaseChooseAnImageFile: "Επιλέξτε ένα αρχείο εικόνας",
    fileIsTooBigSelectUnder1MB: "Το αρχείο σας είναι πολύ μεγάλο! ",
    phoneShouldHave10Chars: "Το τηλέφωνο πρέπει να έχει 10 χαρακτήρες",
    onlyCSVAllowed: "Επιτρέπεται μόνο αρχείο CSV",
    loadingPleaseWait: "Φορτώνει παρακαλώ περιμένετε",
    manager: "διευθυντής",
    administrator: "διαχειριστής",
    Comingsoon: "Ερχομαι συντομα",
    totalAnimals: "Σύνολο ζώων",
    receivedOrders: "Παραγγελίες που ελήφθησαν",
    drugs: "Φάρμακα",
    detailedAnalysis: "Λεπτομερής Ανάλυση",
    barGraphRepOfActiveUsersAndDeactivateUsers: "Γράφημα ράβδων Αναπαράσταση ενεργών χρηστών και ανενεργών χρηστών",
    barGraphRepOfRegAnimalsVsFarm: "Γράφημα ράβδων Αναπαράσταση Εγγεγραμμένων Ζώων εναντίον Φάρμας",
    roleNumber: "Αριθμός Ρόλου",
    roleName: "Όνομα ρόλου",
    active: "Ενεργός",
    inactive: "Αδρανής",
    admin: "διαχειριστής",
    addRole: "Προσθήκη ρόλου",
    addRoles: "Προσθήκη ρόλων",
    permissions: "Άδειες",
    sr: "Sr.",
    moduleName: "Όνομα ενότητας",
    view: "Θέα",
    deptNo: "Τμήμα Αρ.",
    selectByCategory: "Επιλέξτε Κατά κατηγορία",
    weeklyAnalytics: "Εβδομαδιαία Analytics",
    pregnancy: "Εγκυμοσύνη",
    analytics: "Analytics",
    calendar: "Ημερολόγιο",
    productName: "Ονομασία προϊόντος",
    volumeSold: "Πωλήθηκε τόμος",
    recordPoints: "Σημεία εγγραφής",
    inStock: "Σε απόθεμα",
    revenue: "Εσοδα",
    stockStatus: "Κατάσταση μετοχών",
    barChart: "Ραβδόγραμμα",
    lineChart: "Γράφημα γραμμής",
    indexReturns: "Επιστροφές ευρετηρίου",
    chart: "Διάγραμμα",
    time: "χρόνος",
    production: "Παραγωγή",
    customization: "Προσαρμογή",
    recordsPerPage: "Εγγραφές ανά σελίδα",
    noDataAvailable: "Δεν υπάρχουν διαθέσιμα δεδομένα",
    reporting: "Αναφορά",
    optional: "Προαιρετικός",
    note: "Σημείωση",
    notes: "Σημειώσεις",
    date: "Ημερομηνία",
    kG: "ΚΙΛΟ",
    weight: "βάρος",
    type: "Τύπος",
    lessthan3Month: "<3 Μήνας",
    lessthan6Month: "<6 μηνών",
    lessthan7Month: "<7 Μήνας",
    lastWeek: "Την προηγούμενη εβδομάδα",
    thisWeek: "Αυτή την εβδομάδα",
    lessthanOneYear: "<1 Χρόνια",
    lessthanTwoYear: "<2 Χρόνια",
    lessthanThreeYear: "<3 Χρόνια",
    lessthanFourYear: "<4 Χρόνια",
    yes: "Ναί",
    no: "Οχι",
    of: "του",
    notSpecified: "Δεν διευκρινίζεται",
    days: "ημέρες",
    day: "ημέρα",
    aDay: "μια μέρα",
    years: "χρόνια",
    year: "έτος",
    unit: "μονάδα",
    units: "Μονάδες",
    to: "προς την",
    profile: "Προφίλ",
    logOut: "Αποσύνδεση",
    Unit: "Μονάδα",
    otherSettings: "Αλλες ρυθμίσεις",
    somethingWentWrong: "κάτι πήγε στραβά.",
    toDo: "Να κάνω",
    loadingData: "Τα δεδομένα φορτώνονται...",
    taskNumber: "Αριθμός Εργασίας",
    taskName: "Ονομα εργασίας",
    startDate: "Ημερομηνία έναρξης",
    dueDate: "Ημερομηνία λήξης",
    reason: "Λόγος",
    quantity: "Ποσότητα",
    cost: "Κόστος",
    noRecordFound: "Δεν Βρέθηκε Αρχείο",
    dailyUpdates: "Καθημερινές ενημερώσεις",
    weeklyUpdates: "Εβδομαδιαίες ενημερώσεις",
    moduleAccessed: "Πρόσβαση στην ενότητα",
    typesOfAccess: "Τύποι πρόσβασης",
    userId: "Ταυτότητα χρήστη",
    lastLogin: "Τελευταία είσοδος",
    terminalID: "Ταυτότητα τερματικού",
    geographicalAccessPoint: "Γεωγραφικό Σημείο Πρόσβασης",
    iPAddress: "Διεύθυνση IP",
    fileAccessed: "Πρόσβαση στο αρχείο",
    functionAccessed: "Πρόσβαση στη λειτουργία",
    webPageURL: "URL ιστοσελίδας",
    accessType: "Τύπος πρόσβασης",
    unsuccessfulLoginAttempts: "Αποτυχημένες προσπάθειες σύνδεσης",
    customerAddress: "Διεύθυνση Πελάτη",
    orderdate: "Ημερομηνία παραγγελίας",
    postageDate: "Ημερομηνία αποστολής",
    postID: "Ταυτότητα ανάρτησης",
    packingTechnician: "Τεχνικός συσκευασίας",
    packingTechnicia: "Τεχνική συσκευασίας",
    packEdit: "Επεξεργασία πακέτου",
    batchNumber: "Τον αριθμό της παρτίδας",
    collectionTechnician: "Τεχνικός συλλογής",
    collectionTechnicia: "Τεχνική συλλογής",
    preparationTechnicia: "Τεχνική προετοιμασίας",
    preparationTechnician: "Τεχνικός προετοιμασίας",
    approvedManually: "Εγκρίθηκε με μη αυτόματο τρόπο",
    researcher: "Ερευνητής",
    dateOfApproval: "Ημερομηνία Έγκρισης",
    approvalEdit: "Έγκριση Επεξεργασία",
    searchByAllExceptDate: "Αναζήτηση κατά όλους εκτός από την ημερομηνία",
    approval: "Εγκριση",
    collection: "Συλλογή",
    postage: "Ταχυδρομικά τέλη",
    pack: "Πακέτο",
    straws: "Καλαμάκια",
    createdAt: "Δημιουργήθηκε στο",
    sireID: "Ταυτότητα κυρίου",
    economicIndexValue: "Αξία Οικονομικού Δείκτη",
    latestCollectionDate: "Τελευταία ημερομηνία συλλογής",
    locationId: "Αναγνωριστικό τοποθεσίας",
    lastUpdated: "Τελευταία ενημέρωση",
    print: "Τυπώνω",
    save: "Αποθηκεύσετε",
    tax: "Φόρος",
    phoneNo: "Αριθμός τηλεφώνου",
    exportAsPDF: "Εξαγωγή ως PDF",
    statusUpdated: "Κατάσταση Ενημερώθηκε",
    statusNotUpdated: "Η κατάσταση δεν ενημερώθηκε",
    inProgress: "Σε εξέλιξη",
    assignedTo: "Ανατεθεί",
    taskId: "Αναγνωριστικό εργασίας",
    createdDate: "Ημερομηνία δημιουργίας",
    numberOfAnimals: "Αριθμός Ζώων",
    healthRecordSubmittedSuccess: "Το αρχείο υγείας υποβλήθηκε με επιτυχία",
    healthRecordSubmitted: "Υποβλήθηκε Φάκελο Υγείας.",
    InseminationRecordSubmittedSuccesful: "Το αρχείο γονιμοποίησης υποβλήθηκε με επιτυχία",
    inseminationRecordSubmitted: "Υποβλήθηκε αρχείο γονιμοποίησης.",
    actionListDailyTask: "Λίστα ενεργειών - Καθημερινή εργασία",
    sinceLastYear: "Από πέρυσι",
    sinceLastQuarter: "Από το τελευταίο τρίμηνο",
    sinceLastMonth: "Από τον περασμένο μήνα",
    sinceLastWeek: "Από την προηγούμενη εβδομάδα",
    drugWithdrawPeriod: "Περίοδος Απόσυρσης Φαρμάκου",
    diagnosisName: "Όνομα διάγνωσης",
    animalWithNoGenetype: "Αυτό το ζώο δεν έχει καταχωρημένα δεδομένα γονότυπου. ",
    nameOfPreviousOwner: "Όνομα προηγούμενου ιδιοκτήτη",
    avatarSize: "Το μέγεθος του avatar πρέπει να είναι μικρότερο από 1 MB!",
    testDestination: "Προορισμός δοκιμής",
    animalNotAdded: "Ζώο δεν προστέθηκε",
    registerationSuccessful: "Επιτυχής Εγγραφή",
    backToAnimalList: "Επιστροφή στη λίστα ζώων",
    addAnotherAnimal: "Προσθέστε ένα άλλο ζώο",
    animalDetailsUpdated: "Τα στοιχεία των ζώων ενημερώθηκαν με επιτυχία",
    animalUpdatedSuccessfully: "Το Animal ενημερώθηκε με επιτυχία",
    animalNotUpdated: "Το ζώο δεν έχει ενημερωθεί",
    notMember: "Οχι μέλος?",
    requestAccess: "Αίτημα πρόσβασης",
    typePassword: "Πληκτρολογήστε τον κωδικό πρόσβασης.",
    minChars: "τουλάχιστον 6 χαρακτήρες",
    typeConfirmPassword: "πληκτρολογήστε επιβεβαίωση κωδικού πρόσβασης",
    passConfig: "Η επιβεβαίωση κωδικού πρόσβασης δεν ταιριάζει.",
    invalidEmailMobile: "Μη έγκυρη μορφή email/κινητού",
    passwordNotEmpty: "Ο κωδικός πρόσβασης δεν μπορεί να είναι κενός",
    passwordLength: "Το μήκος του κωδικού πρόσβασης δεν μπορεί να είναι μικρότερο από 8 χαρακτήρες",
    cityVillage: "Πόλη / Χωριό",
    districtRegion: "Περιφέρεια / Περιφέρεια",
    alreadyHaveAnAccount: "Έχετε ήδη λογαριασμό;",
    genetypeUpdated: "GenoType Ενημερώθηκε",
    genetypeNotUpdated: "Το GenoType δεν έχει ενημερωθεί",
    sellTrade: "Πώληση/Εμπόριο",
    milkingDevon: "Άρμεγμα απόθεμα αναπαραγωγής Devon προς πώληση",
    detailedDescription: "Λεπτομερής περιγραφή",
    longPara: "Δαμαλίδες και αγελάδες American Milking Devon Bulls. ",
    contactSeller: "Επικοινωνία με τον πωλητή",
    enterListingTitle: "Εισαγάγετε τον τίτλο καταχώρισης",
    livestocktype: "Ζωικό είδος",
    uploadImage: "Ανεβάστε μια εικόνα",
    mobilePhone: "Αριθμός κινητού τηλεφώνου",
    myLivestock: "Το ζωικό μου κεφάλαιο",
    livestockObservations: "Παρατηρήσεις Κτηνοτροφίας",
    selectFromRegisteredAnimals: "Επιλέξτε από τη λίστα εγγεγραμμένων ζώων",
    selectOption: "Επιλέξτε Επιλογή",
    selectTypeObservation: "Επιλέξτε Τύπος παρατήρησης",
    attachVeteinaryDocument: "Επισυνάψτε Κτηνιατρικό Έγγραφο",
    addsensorReading: "Προσθήκη ανάγνωσης αισθητήρα",
    myDocument: "Τα αρχεία μου",
    enterAKeyword: "Εισαγάγετε μια λέξη-κλειδί",
    documentType: "Είδος αρχείου",
    registerEditLivestock: "Εγγραφή/Επεξεργασία Κτηνοτροφίας",
    editLivestockProfile: "Επεξεργασία Προφίλ Ζωικού",
    copy: "αντίγραφο",
    dateOfRegister: "Ημερομηνία εγγραφής",
    livestockType: "Ζωικό είδος",
    registerNewLivestock: "Εγγραφή New Livestock",
    enterUniqueTag: "Εισαγάγετε Μοναδική ετικέτα",
    color: "Χρώμα",
    gender: "Γένος",
    male: "Αρσενικός",
    female: "Θηλυκός",
    damm: "Φράγμα",
    siree: "Αρχοντας",
    dateOfSaleAuction: "Ημερομηνία Πώλησης/Πώληση δημοπρασίας",
    auctionRecord: "Αρχείο δημοπρασίας Deathlist",
    distinguishingFeatures: "Διακριτικά χαρακτηριστικά",
    keywordListing: "Λέξη-κλειδί ή Αναγνωριστικό καταχώρισης",
    adType: "Τύπος διαφήμισης",
    activeListingFund: "Βρέθηκε 1 Ενεργή Καταχώριση",
    setupSensors: "Ρύθμιση αισθητήρων",
    serialNumber: "Σειριακός αριθμός",
    sensorLocation: "Θέση αισθητήρα",
    sensorType: "Τύπος αισθητήρα",
    installationDate: "Ημερομηνία εγκατάστασης",
    ExpirationDate: "Ημερομηνία λήξης",
    addGeo: "Προσθήκη γεωγραφικής θέσης",
    addMoreSensors: "Προσθέστε περισσότερους αισθητήρες",
    trackAndTrace: "Track and Trace",
    createNewShipment: "Δημιουργία νέας αποστολής",
    workflowReference: "Αναφορά ροής εργασιών",
    invoiceDate: "Την ημερομηνία του τιμολογίου",
    trackShipment: "Παρακολούθηση αποστολής",
    totalShipments: "Σύνολο αποστολών",
    activeShipment: "Ενεργές Αποστολές",
    completedObjectives: "Ολοκληρωμένοι Στόχοι",
    processedPayments: "Επεξεργασμένες πληρωμές",
    pointOfDestination: "Σημείο Προορισμού",
    sellerInformation: "Πληροφορίες πωλητή",
    selectSellerConsignor: "Επιλέξτε Πωλητής/Αποστολέας",
    pointOfOrigin: "Σημείο προέλευσης",
    buyerInfo: "Πληροφορίες αγοραστή",
    selectBuyerConsignor: "Επιλέξτε Αγοραστής/Αποστολέας",
    addSensorTriggers: "Προσθήκη ενεργοποίησης αισθητήρων",
    processPayments: "Διαδικασία πληρωμών",
    defineShippingContract: "Καθορισμός συμβολαίου αποστολής",
    addDigitize: "Προσθήκη",
    currentlyOnFarm: "Επί του παρόντος στο Farm",
    addSire: "Προσθήκη κυρίου",
    addApproval: "Προσθήκη Έγκρισης",
    addCollection: "Προσθήκη συλλογής",
    addStraws: "Προσθέστε καλαμάκια",
    addPack: "Προσθήκη πακέτου",
    addPostage: "Προσθήκη ταχυδρομικών εξόδων",
    searchBySire: "Αναζήτηση κατά κύριο",
    anyDataChangeMightBeLost: "Τυχόν αλλαγές δεδομένων ενδέχεται να χαθούν",
    wouldYouLikeToSaveOrWantToLeaveWithoutSaving: "Θέλετε να αποθηκεύσετε ή θέλετε να φύγετε χωρίς αποθήκευση",
    leave: "Αδεια",
    stay: "Διαμονή",
    animalFarm: "Φάρμα ζώων",
    animalFarmH: "Φάρμα ζώων",
    animalOrigin: "Ζωική Προέλευση",
    animalOriginH: "Ζωική Προέλευση",
    farmOfOrigin: "Farm Of Origin",
    farmOfOriginH: "Farm Of Origin",
    selectFarm: "Επιλέξτε Αγρόκτημα",
    searchFarm: "Φάρμα αναζήτησης",
    confirmation: "Επιβεβαίωση",
    proceed: "Προχωρώ",
    ok: "Εντάξει",
    animal: {
      tagH: "Ετικέτα",
      tagNumberH: "Αριθμός ετικέτας: Μπορείτε να προσθέσετε χρώμα αλλά και αριθμό. ",
      goveRegNoH: "Αριθμός που δίνεται κατά την εγγραφή σε κυβερνητικό οργανισμό",
      birthWeightH: "Βάρος γέννησης μοσχαριού",
      birthEaseH: "Η γέννηση στα ζώα είναι μια φυσική διαδικασία, αλλά μερικές φορές μπορεί να υπάρξουν προβλήματα γέννησης όπου το φράγμα χρειάζεται βοήθεια από τον αγρότη/κτηνοτρόφο.",
      birthFarmH: "Αγρόκτημα ζωικής προέλευσης/γέννησης.",
      surrogateDamH: "Η ταυτότητα της θηλυκής αγελάδας στην οποία εμφυτεύεται το γονιμοποιημένο ωάριο από αρσενικό δότη και θηλυκό δότη για την περαιτέρω ανάπτυξή του.",
      ownerH: "Αυτό είναι το όνομα του ιδιοκτήτη του ζώου.",
      damH: "Η ταυτότητα του θηλυκού γονέα/μητέρας του ζώου.",
      sireH: "Η ταυτότητα του αρσενικού γονέα/πατέρα του ζώου.",
      breedH: "Μια φυλή είναι μια συγκεκριμένη ομάδα οικόσιτων ζώων με ομοιογενή εμφάνιση (φαινότυπο), ομοιογενή συμπεριφορά ή/και άλλα χαρακτηριστικά που τη διακρίνουν από άλλους οργανισμούς του ίδιου είδους.",
      conceptionMethodH: "Πώς συνελήφθη το ζώο.",
      genderH: "Το φύλο του ζώου.",
      dobH: "Ημερομηνία γέννησης του ζώου.",
      operatorH: "Το όνομα του ατόμου που συμπληρώνει τα στοιχεία αυτού του ζώου.",
      removalFarmH: "Φάρμα που αφαιρέθηκε με ζώα ",
      dateOfRemovalH: "Ημερομηνία απομάκρυνσης του ζώου",
      destinationOfRemoval: "Τόπος προορισμού του ζώου που αφαιρέθηκε",
      reasonOfRemovalH: "Λόγος απομάκρυνσης του ζώου",
      trackingNumberH: "Αριθμός που αποδίδεται στο ζώο όταν αφαιρείται το ζώο",
      brandH: "Μάρκα-Απλώς ένα μόνιμο σημάδι που κάηκε στην αγελάδα.",
      tattoH: "Τατουάζ σε ζώο.",
      hornStatusH: "Αν το ζώο είναι αποκερατισμένο.",
      animalOriginH: "Η χώρα προέλευσης του ζώου.",
      previousOwnerH: "Όνομα προηγούμενου ιδιοκτήτη του ζώου σε περίπτωση που είναι ώριμο.",
      twinH: "Αυτό το πεδίο λέει αν το ζώο έχει δίδυμο ή όχι.",
      regBreedAssoNoH: "Εγγραφή σε Σωματεία/Εταιρείες φυλών.",
      breedAssoNameH: "Επωνυμία Σωματείων/Εταιρειών όπου καταγράφηκε το ζώο",
      breederH: "Αυτό είναι το όνομα της οργάνωσης που προμήθευσε το ζώο.",
      breeder: "Κτηνοτρόφος",
      noteH: "Σημαντικές σημειώσεις για το ζώο.",
      accuracyWeight_for_field: "Ακρίβεια Βάρος",
      conception: "Σύλληψη",
      addAnAnimal: "Προσθέστε ένα ζώο",
      addAnimal: "Προσθήκη Ζώου",
      registerAnAnimal: "Καταχωρίστε ένα ζώο",
      uploadAnAnimal: "Ανεβάστε ένα ζώο",
      animalRegistration: "Εγγραφή Ζώων",
      animalDetails: "Στοιχεία Ζώου",
      tag: "Ετικέτα",
      tagNumber: "Αριθμός ετικέτας",
      govtRegNumber: "Κυβέρνηση ",
      birthWeight: "Βάρος γέννησης (λίβρες)",
      birthEase: "Ευκολία γέννησης",
      birthFarm: "Φάρμα γεννήσεων",
      surrogateDam: "Υποκατάστατο φράγμα",
      owner: "Ιδιοκτήτης",
      ownershipType: "Τύπος ιδιοκτησίας",
      animalDiseaseRecord: "Animal Disease Record",
      govtReg: "Κυβέρνηση ",
      regDate: "Ημερομηνία Εγγραφής",
      dam: "Φράγμα",
      sire: "Αρχοντας",
      heifer: "Αγελαδίτσα",
      steer: "Διευθύνω",
      calf: "Μοσχάρι",
      farmHerd: "Αγρόκτημα/Αγελάδα",
      femaleCalf: "Θηλυκό μοσχάρι",
      maleCalf: "Αρσενικό μοσχάρι",
      newCalves: "Νέες γάμπες",
      breed: "Ράτσα",
      conceptionMethod: "Μέθοδος Σύλληψης",
      gender: "Γένος",
      dateOfBirth: "Ημερομηνια γεννησης",
      operator: "Χειριστής",
      animalRemovedFarm: "Φάρμα που αφαιρέθηκε με ζώα",
      dateOfAnimalRemoval: "Ημερομηνία Απομάκρυνσης Ζώου",
      destinationOfRemovedAnimal: "Προορισμός του αφαιρεθέντος ζώου",
      reasonOfRemoval: "Λόγος Απομάκρυνσης",
      optionalAnimalInformation: "Προαιρετικές πληροφορίες για τα ζώα",
      animalPicture: "Εικόνα Ζώου",
      trackingNumber: "Αριθμός εντοπισμού",
      brand: "Μάρκα",
      tatto: "Τατουάζ",
      hornStatus: "Κατάσταση κόρνας",
      animalOrigin: "Ζωική Προέλευση",
      previosOwner: "Προηγούμενος Ιδιοκτήτης",
      twin: "Δίδυμο",
      InABreedAssociation: "Καν.",
      nameOfBreedAssociations: "Ονομασία Συλλόγων Φυλών",
      breedAssociations: "Ενώσεις Φυλών",
      breederSupplier: "Εκτροφέας (Προμηθευτής)",
      importAnimal: "Εισαγωγή Ζώου",
      loadingAnimals: "Φόρτωση Ζώων... Περιμένετε",
      totalRegAnimals: "Συνολικός Καν. ",
      totalPregnantAnimals: "Σύνολο έγκυων ζώων",
      pregnantAnimalHistory: "Ιστορία έγκυων ζώων",
      dailyAnimalPregnancyUpdates: "Καθημερινές ενημερώσεις για την εγκυμοσύνη των ζώων",
      animalHistory: "Ιστορία των Ζώων",
      dailyAnimalUpdates: "Καθημερινές ενημερώσεις ζώων",
      totalPregnant: "Συνολικά έγκυος",
      totalNewBorn: "Σύνολο νεογέννητων",
      searchByIDGOVRegTag: "Αναζήτηση κατά ID, GOV Reg και Tag",
      noANIMALAVAILABLE: "ΔΕΝ ΔΙΑΘΕΣΙΜΟ ΖΩΟ",
      associationNumber: "Αριθμός Συνδέσμου",
      associationName: "Όνομα ένωσης",
      destinationName: "Όνομα προορισμού",
      plastic: "Πλαστική ύλη",
      metal: "Μέταλλο",
      naturalMating: "Φυσικό ζευγάρωμα",
      artificialInsemination: "ΤΕΧΝΗΤΗ ΓΟΝΙΜΟΠΟΙΗΣΗ",
      embryoTransfer: "Εμβρυομεταφορά",
      noAssistance: "Καμία Βοήθεια",
      someAssistance: "Κάποια Βοήθεια",
      mechanicalAssistance: "Μηχανική Βοήθεια",
      aCesareanSection: "Καισαρική τομή",
      abnormalDelivery: "Μη φυσιολογική παράδοση",
      male: "Αρσενικός",
      female: "Θηλυκός",
      castrated: "Ευνουχισμένοι",
      sale: "Πώληση",
      slaughter: "Σφαγή",
      death: "Θάνατος",
      theft: "Κλοπή",
      other: "Αλλα",
      horned: "Αυτός που έχει κέρατα",
      polled: "Δημοσκόπηση",
      dehorned: "Αποκερατισμένος",
      details: "Λεπτομέριες",
      performance: "Εκτέλεση",
      geneticWorth: "Γενετική Αξία",
      healthRecord: "Αρχείο Υγείας",
      genotypeData: "Δεδομένα Γονότυπου",
      reminders: "Υπενθυμίσεις",
      activityLog: "Αρχείο καταγραφής δραστηριότητας",
      activityLogDetails: "Στοιχεία αρχείου καταγραφής δραστηριότητας",
      editAnimal: "Επεξεργασία ζώου",
      familyInfo: "Πληροφορίες για την οικογένεια",
      breedInfo: "Πληροφορίες φυλής",
      identification: "Ταυτοποίηση",
      removalInfo: "Πληροφορίες αφαίρεσης",
      iDOfAnimalDam: "Ταυτότητα φράγματος ζώων.",
      iDOfAnimalSire: "Ταυτότητα του πατέρα του ζώου.",
      iDOfDamEmbryoUsed: "Ταυτότητα του φράγματος του εμβρύου του οποίου χρησιμοποιήθηκε.",
      animalHasATwinOrNot: "Είτε το ζώο έχει δίδυμο είτε όχι.",
      breedType: "Τύπος φυλής",
      breedOfTheAnimal: "Αυτή είναι μια ράτσα του ζώου.",
      regBreedAssociations: "Εγγραφή σε Ενώσεις/Εταιρείες φυλών.",
      nameOfAssociationsSocieties: "Επωνυμία Σωματείων/Εταιρειών όπου καταγράφηκε το ζώο.",
      nameOfTheOrgSuppliedAnimal: "Αυτό είναι το όνομα της οργάνωσης που προμήθευσε το ζώο.",
      countryOriginAnimal: "Η χώρα προέλευσης του ζώου.",
      birthFarmID: "Ταυτότητα Γεννητικής Φάρμας",
      farmIDAnimalBorn: "Η ταυτότητα της φάρμας όπου γεννήθηκε το ζώο.",
      currentOwner: "Τρέχων Ιδιοκτήτης",
      nameOfOwnerAnimal: "Αυτό είναι το όνομα του ιδιοκτήτη του ζώου.",
      registrationDate: "Ημερομηνία Εγγραφής",
      previousOwner: "Προηγούμενος ιδιοκτήτης",
      nameOfOperator: "Όνομα χειριστή",
      dateAnimalRemoved: "Ημερομηνία αφαίρεσης του ζώου.",
      destinationPlaceRemovedAnimal: "Τόπος προορισμού για το ζώο που αφαιρέθηκε",
      namePersonFillAnimalInformation: "Το όνομα του ατόμου που συμπληρώνει τα στοιχεία αυτού του ζώου.",
      reasonOfAnimalRemoval: "Λόγος απομάκρυνσης του ζώου",
      reasonWhyTheAnimalIsRemoved: "Λόγος για τον οποίο αφαιρείται το ζώο",
      processingDate: "Ημερομηνία επεξεργασίας",
      DateInformationFilledChanged: "Η ημερομηνία κατά την οποία συμπληρώθηκαν ή άλλαξαν οι τρέχουσες πληροφορίες.",
      animalID: "Ταυτότητα ζώου",
      UniqueIdAnimal: "Αυτή είναι η μοναδική ταυτότητα του ζώου.",
      plasticTagNumber: "Αριθμός πλαστικής ετικέτας",
      numberAnimalTag: "Αριθμός της ετικέτας Animal.",
      rFTagNumber: "Αριθμός ετικέτας RF",
      numberAnimalRFTag: "Αριθμός της ετικέτας RF ζώου.",
      govtRegNumb: "Κυβέρνηση ",
      govtRegistrationNumber: "Στοιχεία αναγνώρισης που μπορεί να περιλαμβάνουν το όνομα και τη διεύθυνση του ατόμου, τον αντιπρόσωπο του ατόμου για την υπηρεσία της διαδικασίας, την τοποθεσία της δραστηριότητας που θα εκτελεστεί και μια περιγραφή της υπηρεσίας που παρέχει το άτομο.",
      numberAssignedAnimalIsRemoved: "Ο αριθμός παρακολούθησης είναι ένα από τα αναγνωριστικά των ζώων που χρησιμοποιούνται για την παρακολούθηση της δραστηριότητας των ζώων.",
      dateOfAnimalRegistration: "Ημερομηνία καταγραφής ζώων",
      stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal: "Μάρκα-Απλώς ένα μόνιμο σημάδι που κάηκε στην αγελάδα.",
      tattoOnAnimal: "Τατουάζ σε ζώο.",
      whetherTheAnimalIsDehorned: "Αν το ζώο είναι αποκερατισμένο.",
      milkingAnimals: "Αρμεκτική Ζώα",
      studAnimals: "Stud Animals",
      animalInseminationRecord: "Αρχείο γονιμοποίησης ζώων",
      numOfStrawsOrdered: "Αριθμός καλαμιών που παραγγέλθηκαν",
      totalNumOfStraws: "Συνολικός Αριθμός Καλαμιών",
      strawId: "Straw Id",
      addSireAutomation: "Προσθήκη Sire Automation",
      addApprovalAutomation: "Προσθήκη Αυτοματισμού Έγκρισης",
      addCollectionAutomation: "Προσθήκη Αυτοματισμού Συλλογής",
      addStrawsAutomation: "Προσθήκη Straws Automation",
      addPackAutomation: "Προσθήκη Αυτοματισμού πακέτων",
      addPostageAutomation: "Προσθήκη Αυτοματισμού Ταχυδρομικών Αποστολών",
      searchBySire: "searchBySire",
      numberOfProgenies: "Αριθμός Απογόνων",
      sireEdit: "Sire Edit",
      searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId: "Αναζήτηση κατά Straw ID, Συνολικοί Αριθμοί Καλαμιών, Αριθμός παρτίδας και Αναγνωριστικό Τοποθεσίας",
      searchByPackIdNumberOfStrawsOrderedPackingTechnicia: "Αναζήτηση ανά αναγνωριστικό πακέτου, αριθμός παραγγελθέντων καλαμιών, Τεχνική συσκευασίας",
      searchByCollectionAndPreparationTechnicia: "Αναζήτηση ανά τεχνικό συλλογής και προετοιμασίας",
      registerSemenAutomation: "Εγγραφή Αυτοματισμού Σπέρματος",
      addSemenAutomation: "Προσθήκη Αυτοματισμού Σπέρματος",
      strawAutomationRegistered: "Εγγεγραμμένος αυτοματισμός αχύρου",
      strawAutomationRegisteredNotRegistered: "Straw Automation Εγγεγραμμένος Μη Εγγεγραμμένος",
      sireAutomationRegistered: "Η Sire Automation έχει καταχωρηθεί",
      sireAutomationNotRegistered: "Η Sire Automation δεν έχει καταχωρηθεί",
      postageAutomationIsRegistered: "Ο Αυτοματισμός Ταχυδρομικών Τελών έχει καταχωρηθεί",
      postageAutomationNotRegistered: "Αυτοματισμός Ταχυδρομικών Ταχυδρομείων δεν έχει καταχωρηθεί",
      packAutomationIsRegistered: "Το Pack Automation έχει καταχωρηθεί",
      packAutomationNotRegistered: "Ο αυτοματισμός συσκευασίας δεν έχει καταχωρηθεί",
      postageAutomationIsUpdated: "Ο αυτοματισμός ταχυδρομικών τελών ενημερώθηκε",
      postageAutomationNotUpdated: "Ο αυτοματισμός ταχυδρομικών τελών δεν ενημερώθηκε",
      packAutomationIsUpadted: "Το Pack Automation ενημερώθηκε",
      packAutomationNotUpadted: "Ο αυτοματισμός πακέτου δεν ενημερώθηκε",
      collectionAutomationUpdated: "Ο αυτοματισμός συλλογής ενημερώθηκε",
      collectionAutomationNotUpdated: "Ο αυτοματισμός συλλογής δεν ενημερώθηκε",
      approvalAutomationIsUpdated: "Ο αυτοματισμός έγκρισης ενημερώθηκε",
      approvalAutomationIsNotUpdated: "Ο αυτοματισμός έγκρισης δεν έχει ενημερωθεί",
      collectionAutomationRegistered: "Εγγεγραμμένος αυτοματισμός συλλογής",
      collectionAutomationNotRegistered: "Ο αυτοματισμός συλλογής δεν έχει καταχωρηθεί",
      approvalAutomationIsRegistered: "Ο αυτοματισμός έγκρισης έχει καταχωρηθεί",
      approvalAutomationIsNotRegistered: "Ο αυτοματισμός έγκρισης δεν έχει καταχωρηθεί",
      strawAutomationUpdated: "Ο αυτοματισμός άχυρου ενημερώθηκε",
      strawAutomationIsNotUpdated: "Το Straw Automation δεν έχει ενημερωθεί",
      searchSire: "Αναζήτηση Κυρίου",
      strawsEdit: "Straws Επεξεργασία",
      nextAnimals: "Επόμενο Ζώο",
      performanceInfo: {
        milk: "Γάλα",
        liveweight: "Ζωντανό βάρος",
        score: "Σκορ",
        fertility: "Γονιμότητα",
        measurements: "Μετρήσεις",
        dailyProteinYield: "Ημερήσια απόδοση πρωτεΐνης",
        amountProteinMilkCowDay: "Ποσότητα πρωτεΐνης στο γάλα που λαμβάνεται από μια αγελάδα τη συγκεκριμένη ημέρα.",
        dailyMilkYield: "Ημερήσια απόδοση γάλακτος",
        volumeMilkCowDay: "Όγκος γάλακτος που λαμβάνεται από μια συγκεκριμένη αγελάδα σε μια συγκεκριμένη ημέρα.",
        dailyFatYield: "Ημερήσια απόδοση λίπους",
        amountFatMilkCowDay: "Ποσότητα λίπους στο γάλα που λαμβάνεται από μια αγελάδα τη συγκεκριμένη ημέρα.",
        dailyProteinContent: "Ημερήσια περιεκτικότητα σε πρωτεΐνη",
        dailyFatContent: "Ημερήσια περιεκτικότητα σε λιπαρά",
        milkLactose: "Γάλα Λακτόζη",
        amountLactoseMilk: "Ποσότητα λακτόζης στο γάλα.",
        milkUrea: "Γάλα Ουρία",
        indicatorAmountCrudeProtein: "Δείκτης της ποσότητας ακατέργαστης πρωτεΐνης στη διατροφή μιας αγελάδας",
        lactationNumber: "Αριθμός γαλουχίας",
        ordinalNumLactation: "Ο τακτικός αριθμός της γαλουχίας.",
        lengthOfLactation: "Διάρκεια γαλουχίας (π.χ. 23 ημέρες)",
        lactationLength: "Διάρκεια γαλουχίας",
        milkingFrequency: "Συχνότητα Αρμέγματος",
        frequcnyOfMilking: "Συχνότητα αρμέγματος (π.χ. 2 φορές/ημέρα)",
        liveWeightInformation: "Πληροφορίες Liveweight",
        currentWeight: "Τρέχον βάρος",
        weightAnimal: "Βάρος του ζώου.",
        postWeaningGain: "Κέρδος μετά τον απογαλακτισμό",
        dailyGainInAnimalWeightWeaning: "Καθημερινή αύξηση βάρους του ζώου μετά τον απογαλακτισμό.",
        weaningWeight: "Βάρος απογαλακτισμού",
        weightAnimalMeasuredWeaning: "Το βάρος του ζώου μετράται σε μια ημέρα απογαλακτισμού.",
        averageDailyGain: "Μέση Ημερήσια Κέρδος",
        averageAmountWeightAnimalGainFeedingPeriod: "Η μέση ποσότητα βάρους που θα κερδίζει ένα ζώο κάθε μέρα κατά τη διάρκεια της περιόδου σίτισης",
        carcassWeight: "Βάρος σφαγίου",
        weightAnimalsHideInternalOrgansRemoved: "Βάρος ζώων μετά την αφαίρεση του κεφαλιού, του δέρματος και των εσωτερικών οργάνων.",
        weightAtCalving: "Βάρος κατά τον τοκετό",
        weightAtTheTimeOfCalving: "Βάρος τη στιγμή του τοκετού.",
        yearlingWeight: "Ετήσιο βάρος",
        weightYearOldAnimal: "Βάρος ζώου ενός έτους.",
        somaticCellScore: "Βαθμολογία σωματικών κυττάρων",
        somaticCellScoreIndicatorMastitis: "Η βαθμολογία σωματικών κυττάρων ως δείκτης για μαστίτιδα. ",
        lastUpdate: "Τελευταία ενημέρωση",
        bodyConditionScore: "Βαθμολογία κατάστασης σώματος",
        scoreAnimalFat: "Μια βαθμολογία ζώου σε σχέση με το πόσα λίπη έχει.  ",
        teatScore: "Σκορ Θηλής",
        scoreMeasureingShapeTeats: "Οι βαθμολογίες μεγέθους θηλής είναι υποκειμενικές εκτιμήσεις του μήκους και της περιφέρειας της θηλής και κυμαίνονται από 9 (πολύ μικρό) έως 1 (πολύ μεγάλο). ",
        udderScore: "Βαθμολογία αναστολής του μαστού",
        scoreMeasureingShapeOfUdder: "Σχήμα μέτρησης βαθμολογίας μαστού (1-9 σκορ). ",
        whetherAnimalEasyBirthDifficult: "Η γέννηση στα ζώα είναι μια φυσική διαδικασία, αλλά μερικές φορές μπορεί να υπάρξουν προβλήματα γέννησης όπου το φράγμα χρειάζεται βοήθεια από τον αγρότη/κτηνοτρόφο.",
        totalLongevity: "Ολική μακροζωία",
        survivalLactationTraitCowCulledBreeding: "Επιβίωση από 1η έως 5η γαλουχία. ",
        docility: "υπακοή",
        circumferenceBullScrotal: "Περιφέρεια οσχέου ταύρου",
        intervalSuccessInsemination: "Μεσοδιάστημα από την πρώτη έως την επιτυχή γονιμοποίηση.",
        ageAtFirstCalving: "Ηλικία κατά τον πρώτο τοκετό",
        ageCowCalving: "Ποια είναι η ηλικία της αγελάδας στον πρώτο τοκετό.",
        calvingInterval: "Διάστημα τοκετού",
        periodCalving: "Η περίοδος από τον ένα τοκετό στον επόμενο τοκετό.",
        scrotalCircumference: "Περιφέρεια οσχέου",
        estrusDetection: "Ανίχνευση οίστρου",
        trackingBehaviorAnimalDetectingEstrus: "Παρακολούθηση κίνησης συμπεριφοράς ζώου για ανίχνευση οίστρου αγελάδας.",
        presenceOfEstrus: "Παρουσία Οίστρου",
        isCowInEstrusStage: "Είναι όταν μια αγελάδα βρίσκεται στο στάδιο του οίστρου ή ούτε",
        matureWeight: "Ώριμο Βάρος",
        weightAnimalDefinedAge: "Βάρος ζώου σε καθορισμένη ηλικία.",
        matureHeight: "Ώριμο ύψος",
        heightAnimalDefinedAge: "Ύψος ζώου σε καθορισμένη ηλικία.",
        footClawSet: "Σετ νυχιών ποδιών",
        shapeAnimalClaw: "Σχήμα νυχιού ζώου.",
        pulmonaryArterialPressure: "Πνευμονική Αρτηριακή Πίεση",
        animalBloodPreasure: "Η πίεση του αίματος του ζώου.",
        footAngle: "Γωνία ποδιού",
        shapeAnimalFoot: "Σχήμα ποδιού ζώου.",
        ribEyeArea: "Περιοχή πλευρών-ματιών",
        amountRibEyeArea: "Ποσότητα περιοχής πλευρών-ματιών.",
        ultrasoundFat: "Λίπος υπερήχων",
        measureFatAmount: "Μέτρηση της ποσότητας λίπους.",
        ultrasoundIntramuscularFat: "Υπερηχογράφημα Ενδομυϊκό Λίπος",
        ultrasoundRibEyeArea: "Περιοχή πλευρών-ματιών υπερήχων",
        measureRibeyeArea: "Μέτρο περιοχής ribeye.",
        fatThickness: "Πάχος λίπους",
        amountAnimalBackFat: "Ποσότητα λίπους στην πλάτη του ζώου.",
        marbling: "Μαρμαροποίηση",
        marballingMeasurement: "Το μάρμαρο είναι το ορατό ακόρεστο (υγιές) ενδομυϊκό λίπος που συσσωρεύεται εντός του μυός και μεταξύ των δεσμών των μυϊκών ινών.",
        dryMatterIntake: "Πρόσληψη ξηράς ύλης",
        amountFeedAnimalConsumesAMoisture: "Ποσότητα τροφής που καταναλώνει ένα ζώο την ημέρα σε βάση χωρίς υγρασία."
      },
      feedsName: "Όνομα ροών",
      feedName: "Όνομα ροής",
      firstFeedQuantity: "Ποσότητα πρώτης τροφοδοσίας",
      additionalFeed: "Πρόσθετη τροφοδοσία",
      cloversRyeGrasses: "Τριφύλλια, χόρτα σίκαλης",
      greenFodderHayLegumes: "Πράσινη χορτονομή, σανός, όσπρια",
      feedsRegisteredSuccessfully: "Οι ροές καταχωρήθηκαν με επιτυχία",
      feedsNotRegistered: "Οι ροές δεν έχουν καταχωρηθεί",
      fEEDQUANTITY: "ΠΟΣΟΤΗΤΑ ΤΡΟΦΗΣ",
      feedQuantity: "Ποσότητα ζωοτροφών",
      fEEDNAME: "ΟΝΟΜΑ ΤΡΟΦΗΣ",
      nOFEEDINFOAVAILABLE: "ΔΕΝ ΥΠΑΡΧΟΥΝ ΔΙΑΘΕΣΙΜΕΣ ΠΛΗΡΟΦΟΡΙΕΣ ΤΡΟΦΗΣ",
      searchByFeedName: "Αναζήτηση με βάση το όνομα ροής",
      loadingFeedInfo: "Φόρτωση πληροφοριών ροής... Περιμένετε",
      todayFeedInfo: "Πληροφορίες τροφοδοσίας σήμερα",
      feedInfo: "Πληροφορίες ροής",
      loremIpsumDolorSitAmet: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      geneticWorthInfo: {
        breedingValueEconomicIndex: "Εάν αυτή η αξία αναπαραγωγής χρησιμοποιείται για τον υπολογισμό του οικονομικού δείκτη.",
        dailyProteinYieldUsed: "Ημερήσια απόδοση πρωτεΐνης που χρησιμοποιείται",
        weightAssignedBreedingDailyProteinYield: "Βάρος που αποδίδεται στην αναπαραγωγική αξία που αντιστοιχεί στην \"Ημερήσια απόδοση πρωτεΐνης\" ",
        dailyProteinYieldWeight: "Βάρος ημερήσιας απόδοσης πρωτεΐνης",
        rankAnimalInRelationshipEconomicIndex: "Κατάταξη του ζώου σε σχέση με τον οικονομικό δείκτη.",
        economicIndexRank: "Κατάταξη Οικονομικού Δείκτη",
        percentileEconomicIndexFall: "Ποσοστό σε ποιο οικονομικό δείκτη εμπίπτει.",
        economicIndexPercentile: "Ποσοστό του Οικονομικού Δείκτη",
        accuracyOfEconomicIndex: "Ακρίβεια του οικονομικού δείκτη.",
        economicIndexAccuracy: "Ακρίβεια Οικονομικού Δείκτη",
        weightedAverageOfBreedingValues: "Σταθμισμένος μέσος όρος των τιμών αναπαραγωγής.",
        economicIndex: "Οικονομικός Δείκτης",
        rankOfAnimalInRelationshipBreeding: "Κατάταξη του ζώου σε σχέση με την αντίστοιχη αναπαραγωγική αξία.",
        dailyProteinYieldBreedingValueRank: "Κατάταξη αναπαραγωγικής αξίας ημερήσιας απόδοσης πρωτεΐνης ",
        percentileBreedingFalls: "Ποσοστό στο οποίο εμπίπτει η αναπαραγωγική αξία.",
        dailyProteinYieldBreedingPercentile: "Ημερήσια απόδοση πρωτεΐνης εκατοστημόριο αξίας αναπαραγωγής ",
        accuracyEstimatedBreeding: "Ακρίβεια της εκτιμώμενης αξίας αναπαραγωγής.",
        dailyProteinYieldBreedingAccuracy: "Ημερήσια Ακρίβεια Αναπαραγωγικής Αξίας Απόδοσης Πρωτεϊνών",
        estimatedBreedingTraitDailyProteinYield: "Εκτιμώμενη αναπαραγωγική αξία του χαρακτηριστικού «Ημερήσια απόδοση πρωτεΐνης.",
        dailyProteinYieldBreedingValue: "Ημερήσια Αναπαραγωγική Αξία Απόδοσης Πρωτεϊνών ",
        pathToTheDirectoryScriptsBreeding: "Διαδρομή προς τον κατάλογο στον σκληρό δίσκο που περιέχει σενάρια που χρησιμοποιήθηκαν για τον υπολογισμό της αξίας αναπαραγωγής.",
        scriptsPath: "Διαδρομή σεναρίων",
        softwarePackageBreeding: "Πακέτο λογισμικού που χρησιμοποιήθηκε για τον υπολογισμό της αξίας αναπαραγωγής.",
        breedingValueSoftware: "Λογισμικό Breeding Value",
        methodCalculateBreeding: "Η μέθοδος που χρησιμοποιήθηκε για τον υπολογισμό της αναπαραγωγής",
        breedingValueMethod: "Μέθοδος αναπαραγωγικής αξίας",
        trait: "Χαρακτηριστικό",
        tools: "Εργαλεία",
        geneticWorth: "Γενετική Αξία",
        dailyProteinYield: "Ημερήσια απόδοση πρωτεΐνης",
        breedingValue: "Αναπαραγωγική Αξία",
        breedingValueBIFAccuracy: "Αξία αναπαραγωγής Ακρίβεια BIF",
        breedingValuePercentile: "Ποσοστό Αναπαραγωγικής Αξίας",
        breedingValueRank: "Κατάταξη αξίας αναπαραγωγής",
        checkLTD: "Έλεγχος ΕΠΕ",
        ultrasoundDiagnostic: "Διαγνωστικό με υπερήχους",
        selectYieldUsed: "Επιλέξτε Απόδοση που χρησιμοποιείται",
        softwareName: "Όνομα λογισμικού",
        animalGenWorthUpdatedSuccessfully: "Η Animal Gen Worth ενημερώθηκε με επιτυχία"
      },
      addNote: "Προσθήκη σημείωσης",
      enterNote: "Εισαγάγετε Σημείωση",
      noteIsRequired: "Σημείωση απαιτείται",
      noteMustBeLessThan50Characters: "Η σημείωση πρέπει να είναι μικρότερη από 50 χαρακτήρες",
      noteAdded: "Σημείωση Προστέθηκε",
      noteNotAdded: "Σημείωση δεν προστέθηκε",
      noteForAnimal: "Σημείωση για ζώο.",
      noNoteFoundForThisAnimal: "Δεν βρέθηκε σημείωση για αυτό το ζώο.",
      inseminationData: "Στοιχεία γονιμοποίησης",
      nameOfInseminator: "Όνομα γονιμοποιητή",
      activity: "Δραστηριότητα",
      searchByNameActivity: "Αναζήτηση κατά όνομα, δραστηριότητα",
      searchByTaskNameNumber: "Αναζήτηση κατά όνομα εργασίας, αριθμό",
      inseminationDate: "Ημερομηνία γονιμοποίησης",
      genotypeDataInfo: {
        genotypeAnimalID: "Γονότυπος Ταυτότητα ζώου",
        iDTubeBloodSampleAnimalNumberGenotypingService: "Αυτό είναι το αναγνωριστικό ενός σωλήνα με δείγμα αίματος που λαμβάνεται από το ζώο ή μια σειρά υπηρεσιών γονότυπου",
        geneticTechnicianName: "Όνομα γενετικού τεχνικού",
        NameTechnicianBloodSamplesAnimal: "Αυτό είναι το όνομα ενός τεχνικού που πήρε δείγματα αίματος από το ζώο",
        sNPData: "Δεδομένα SNP",
        genotypingServiceNote: "Σημείωση υπηρεσίας γονότυπου",
        InfoGenotypingGenotypingTechnology: "Όλες οι πληροφορίες που σχετίζονται με τον προσδιορισμό γονότυπου όπως το όνομα της εταιρείας γονότυπου, η χρησιμοποιούμενη τεχνολογία γονότυπου, η ημερομηνία γονότυπου κ.λπ.",
        numberOfSNPs: "Αριθμός SNP",
        numberOfSNPsAnimalGenotyped: "Αριθμός SNP για τα οποία έγινε ο γονότυπος του ζώου",
        nameOfTheDrug: "Όνομα του φαρμάκου",
        animalGenoDataUpdatedSuccessfully: "Τα δεδομένα γονιδίου των ζώων ενημερώθηκαν με επιτυχία",
        animalGenoDataNotUpdated: "Τα δεδομένα γονιδίου των ζώων δεν έχουν ενημερωθεί",
        animalIDIsRequired: "Απαιτείται ταυτότητα ζώου",
        techNameIsRequired: "Τεχν. ",
        onlyAlphabetsAreAllowed: "Επιτρέπονται μόνο αλφάβητα",
        genoDataIsRequired: "Απαιτούνται δεδομένα Geno",
        serviceNoteIsRequired: "Απαιτείται Σημείωση Σέρβις",
        sNPIsRequired: "Απαιτείται SNP"
      },
      healthRecordInfo: {
        treatment: "Θεραπεία",
        treatmentTakenAnimal: "Τι θεραπεία έλαβε το ζώο.",
        reasonOfTreatment: "Λόγος Θεραπείας",
        reasonForTreatment: "Λόγος θεραπείας",
        whatReasonOfTreatment: "Ποιος είναι ο λόγος της θεραπείας.",
        treatmentDate: "Ημερομηνία θεραπείας",
        dateOfTreatment: "Ημερομηνία θεραπείας.",
        diagnosis: "Διάγνωση",
        nameDiagnosedDiseaseConditionSymptoms: "Όνομα της διαγνωσθείσας νόσου/κατάστασης ή κύρια συμπτώματα",
        drugID: "Ταυτότητα φαρμάκου",
        iDOfDrugWhichIsGivenToAnimal: "Ταυτότητα φαρμάκου που χορηγείται σε ζώο.",
        drugName: "Όνομα φαρμάκου",
        nameDrugAnimal: "Ονομασία του φαρμάκου που δίνεται στο ζώο.",
        drugWithdrawalPeriod: "Περίοδος απόσυρσης φαρμάκων",
        timeAdministrationDrugAnimalMeatMilkHumanConsumption: "Ο χρόνος που απαιτείται μετά τη χορήγηση ενός φαρμάκου σε ένα ζώο για να διασφαλιστεί η ασφάλεια του κρέατος ή του γάλακτος για ανθρώπινη κατανάλωση",
        attendingVeterinarian: "Παρακολούθηση Κτηνίατρου",
        qualifiedPersonCaseAnimal: "Το ειδικευμένο άτομο που είδε την υπόθεση/ζώο",
        packID: "Αναγνωριστικό πακέτου",
        iDPackTreatment: "Ταυτότητα συσκευασίας που χρησιμοποιήθηκε για θεραπεία",
        veterinarianName: "Όνομα κτηνιάτρου",
        animalNoHealthRecord: "Αυτό το ζώο δεν έχει κανένα αρχείο υγείας. ",
        addHealthRecord: "Προσθήκη αρχείου υγείας",
        healthStatus: "Κατάσταση υγείας",
        loadingDiseasesPleaseWait: "Φόρτωση Ασθένειες... Περιμένετε",
        animalDiseaseRecord: "Αρχείο ασθενειών ζώων",
        animalHealthRecord: "Αρχείο Υγείας των Ζώων",
        animalTreatmentRecord: "Αρχείο θεραπείας ζώων",
        loadingHealthData: "Φόρτωση δεδομένων υγείας...",
        healthRecord: "Αρχείο Υγείας",
        nameOfDiagnosis: "Όνομα της διάγνωσης",
        treatmentName: "Όνομα θεραπείας",
        drugGivenBy: "Φάρμακο που χορηγείται από",
        recessiveDiseases: "Υπολειπόμενα Νοσήματα",
        recessiveDiseasesMessage: "Ποια αλληλόμορφα υπολειπόμενης νόσου είναι φορέας αυτός ο ταύρος"
      },
      conceptionInfo: {
        addNewConception: "Προσθέστε νέα αντίληψη",
        semenEmbryo: "Σπέρμα/Έμβρυο",
        pregnancyCheck: "Έλεγχος εγκυμοσύνης",
        birthInfo: "Πληροφορίες Γέννησης",
        searchByInseminatorOrganisationBreedingConception: "Αναζήτηση κατά όνομα σπερματικού, όνομα οργανισμού, αριθμό υπηρεσίας αναπαραγωγής, μέθοδος σύλληψης",
        deliveryDate: "Ημερομηνία παράδοσης",
        calfId: "Calf Id",
        birthDayOldWeight: "Βάρος γέννησης (ημέρας).",
        searchByBirthEase: "Ευκολία αναζήτησης κατά γέννηση",
        searchPregnancyCheckOperatorMethod: "Αναζήτηση ανά χειριστή ελέγχου εγκυμοσύνης, Μέθοδος ελέγχου εγκυμοσύνης",
        pregnancyCheckDate: "Ημερομηνία ελέγχου εγκυμοσύνης",
        conceptionSuccess: "Επιτυχία σύλληψης",
        pregnancyCheckOperator: "Χειριστής ελέγχου εγκυμοσύνης",
        pregnancyCheckMethod: "Μέθοδος ελέγχου εγκυμοσύνης",
        recentlyPregnant: "Πρόσφατα Έγκυος",
        pregnancyConfirmationDate: "Ημερομηνία επιβεβαίωσης εγκυμοσύνης",
        pregnancyRate: "Ποσοστό εγκυμοσύνης",
        timePeriodOfPregnancy: "Χρονική Περίοδος Εγκυμοσύνης",
        semenProduction: "Παραγωγή σπέρματος",
        embryoProduction: "Εμβρυοπαραγωγή",
        semen: "σπέρμα",
        embryoTransferDate: "Ημερομηνία Μεταφοράς Εμβρύου",
        daysOfPregnancy: "Ημέρες Εγκυμοσύνης",
        searchSireEmbryoSurrogate: "Αναζήτηση κατά Sire id, Embryo org name, Surrogate dam breed",
        selectDate: "Επιλέξτε Ημερομηνία",
        orgnisationNameContainNumber: "Το όνομα του οργανισμού δεν πρέπει να περιέχει αριθμό",
        selectBirthEase: "Επιλέξτε Birth Ease",
        selectUnit: "Επιλέξτε μια μονάδα",
        animalConceptionAddedSuccessfully: "Η σύλληψη ζώων προστέθηκε με επιτυχία",
        postageCustomerName: "Ταχυδρομικά τέλη Όνομα πελάτη",
        searchByPostageCustNameCustAddPostId: "Αναζήτηση με ταχυδρομικά τέλη Όνομα πελάτη, Διεύθυνση Πελάτη, Αναγνωριστικό Ταχυδρομείου",
        dateOfSemenCollection: "Ημερομηνία συλλογής σπέρματος",
        dateOfSemenPreparation: "Ημερομηνία Παρασκευής Σπέρματος",
        semenMotility: "Κινητικότητα σπέρματος",
        semenConcentration: "Συγκέντρωση σπέρματος",
        postageEdit: "Επεξεργασία ταχυδρομικών τελών",
        enterSireId: "Εισαγάγετε το Sire ID",
        selectEmbryoOrganisation: "Επιλέξτε Οργάνωση Εμβρύου",
        matingDateH: "Ημερομηνία σύλληψης, είτε φυσικό ζευγάρωμα είτε τεχνητή γονιμοποίηση.",
        inseminatorNameH: "Άτομο που εκτελεί τη διαδικασία γονιμοποίησης (κτηνίατρος/τεχνικός)",
        orgNameH: "Όνομα του οργανισμού ή της εταιρείας που παρέχει το άχυρο σπέρματος για AI",
        brServiceNumH: "Καταγραφή του αριθμού αναπαραγωγής (π.χ. 1η, 2η ή 3η)",
        conceptionMethodH: "Ο τρόπος με τον οποίο το ζώο συνέλαβε ότι είναι η αρχή της εγκυμοσύνης, που χαρακτηρίζεται από τη γονιμοποίηση ενός ωαρίου από ένα σπέρμα.",
        sireIdH: "Η ταυτότητα του αρσενικού γονέα/πατέρα του ζώου",
        damIdH: "Η ταυτότητα του θηλυκού γονέα/μητέρας του ζώου.",
        sarogatedDamH: "Η ταυτότητα της θηλυκής αγελάδας στην οποία εμφυτεύεται το γονιμοποιημένο ωάριο από αρσενικό δότη και θηλυκό δότη για την περαιτέρω ανάπτυξή του.",
        embOrgNameH: "Το όνομα του οργανισμού για το έμβρυο",
        sarogateDamBreedH: "Η ημερομηνία της παρένθετης φυλής",
        sireBreedH: "Ο τύπος της φυλής του γένους (brahman, boran)",
        pregCheckDateH: "Η εγκυμοσύνη μπορεί να ανιχνευθεί σε αγελάδες ήδη από τις 30 ημέρες χρησιμοποιώντας υπερηχογράφημα και εξετάσεις αίματος. Για να αναγνωριστούν οι αγελάδες ως έγκυες χρησιμοποιώντας τη μέθοδο ψηλάφησης, οι αγελάδες συχνά χρειάζεται να είναι τουλάχιστον 35-50 ημέρες έγκυες. ",
        conceptionSuccessH: " Στα βοοειδή, το ποσοστό γονιμοποίησης είναι 90% με μέσο ποσοστό τοκετού περίπου 55%, υποδεικνύοντας μια εμβρυϊκή-εμβρυϊκή θνησιμότητα περίπου 35% (Diskin et al., 2006). ",
        pregnancyCheckOperatorH: "Οι κτηνίατροι και οι ειδικοί τεχνικοί ζώων παρέχουν συνήθως αυτές τις υπηρεσίες στους αγρότες. ",
        pregnancyCheckMethodH: "Οι δύο πιο συχνά χρησιμοποιούμενες μέθοδοι για τη διάγνωση της εγκυμοσύνης των βοοειδών είναι η χειρωνακτική ψηλάφηση της αναπαραγωγικής οδού (ανά ορθό) και το διορθικό υπερηχογράφημα της αναπαραγωγικής οδού.",
        deliveryDateH: "Ημερομηνία που έγινε ο τοκετός",
        calfIdH: "Ταυτότητα νεογέννητου μοσχαριού",
        birthEaseH: "Η γέννηση στα ζώα είναι μια φυσική διαδικασία, αλλά μερικές φορές μπορεί να υπάρξουν προβλήματα γέννησης όπου το φράγμα χρειάζεται βοήθεια από τον αγρότη/κτηνοτρόφο.",
        birthDayOldWeightH: "Βάρος ζώου την ημέρα γέννησης ή βάρος πουλιού μιας ημέρας",
        customerAddress: "Διεύθυνση Πελάτη"
      },
      all: "Ολα",
      ungrouped: "Μη ομαδοποιημένα ζώα",
      active: "Ομαδοποιημένα ζώα",
      updateAnimal: "Ενημέρωση Animal"
    },
    dashboardS: {
      dailyActivities: "Καθημερινές δραστηριότητες",
      pendingTasks: "Εκκρεμείς εργασίες",
      performanceOfGeno: "Απόδοση Γονοτύπων",
      breed: "Ράτσα",
      chromosome: "Χρωμόσωμα",
      seqChange: "Αλλαγή ακολουθίας",
      inheritance: "Κληρονομία",
      diseaseName: "Όνομα ασθένειας",
      refSequence: "Ακολουθία αναφοράς",
      pubmedRef: "Δημοσιευμένη αναφορά",
      matingDate: "Ημερομηνία Ζευγαρώματος",
      inseminatorName: "Όνομα σπερματοδότη",
      orgName: "Όνομα Οργανισμού",
      brServiceNum: "Αριθμός υπηρεσίας αναπαραγωγής",
      conceptionMethod: "Μέθοδος Σύλληψης",
      semEmbInfo: "Πληροφορίες για το σπέρμα/έμβρυο",
      sireId: "Ταυτότητα κυρίου",
      damID: "Ταυτότητα φράγματος",
      srgDamId: "Αναγνωριστικό φράγματος",
      embOrgName: "Embryo Org. ",
      srgDamBreed: "Ράτσα Surrogate Dam",
      sireBreed: "Sire Breed",
      damBreed: "Dam Breed"
    },
    user: {
      selectLanguage: "Επιλέξτε γλώσσα",
      unitPreference: "Προτίμηση μονάδας",
      selectUnitOfMeasure: "Επιλέξτε μονάδα μέτρησης",
      importedUser: "Εισαγόμενος χρήστης",
      impFileStatus: "Εισαγωγή κατάστασης αρχείου",
      loadingUser: "Φόρτωση χρηστών... Περιμένετε",
      totalUsers: "Σύνολο χρηστών",
      pendingUsers: "Χρήστες σε εκκρεμότητα",
      changePassword: "Άλλαξε κωδικό",
      goodIdeaToUsePassword: "Είναι καλή ιδέα να χρησιμοποιήσετε έναν ισχυρό κωδικό πρόσβασης που δεν χρησιμοποιείτε αλλού.",
      enterCurrentPassword: "Πληκτρολογήστε τον τρέχοντα κωδικό πρόσβασης",
      enterNewPassword: "Εισάγετε νέο κωδικό",
      reEnterPassword: "Εισαγάγετε ξανά τον νέο κωδικό πρόσβασης",
      enterPassword: "Εισάγετε τον κωδικό πρόσβασης",
      repeatNewPassword: "Επαναλάβετε τον νέο κωδικό πρόσβασης",
      emailAddr: "Διεύθυνση ηλεκτρονικού ταχυδρομείου",
      enterYourPhoneNumber: "Πληκτρολόγησε τον αριθμό του τηλεφώνου σου",
      pleaseTypeOldPassword: "Πληκτρολογήστε τον παλιό κωδικό πρόσβασης.",
      pleaseTypeNewPassword: "Πληκτρολογήστε νέο κωδικό πρόσβασης.",
      pleaseTypeConfirmPassword: "Πληκτρολογήστε τον κωδικό επιβεβαίωσης.",
      passwordChangedSuccesFully: "Ο κωδικός άλλαξε επιτυχώς",
      currentPassword: "Τρέχων κωδικός πρόσβασης",
      newPassword: "Νέος Κωδικός",
      passwordDoesNotMatch: "Οι κωδικοί πρόσβασης δεν ταιριάζουν.",
      emailCanNotBeEmpty: "Το email δεν μπορεί να είναι κενό",
      profileUpdated: "Το προφιλ ενημερωθηκε",
      profileNotUpdated: "Το προφίλ δεν ενημερώθηκε",
      unableToVerifyEmail: "Δεν είναι δυνατή η επαλήθευση του email",
      otpSentOnEmail: "Το OTP εστάλη μέσω email",
      otpSentSuccessFully: "Το OTP στάλθηκε με επιτυχία",
      importUsers: "Εισαγωγή χρηστών",
      imageUpdated: "Η εικόνα ενημερώθηκε",
      departmentName: "όνομα τμήματος",
      departmentNum: "Αριθμός Τμήματος",
      departmentAdded: "Προστέθηκε τμήμα",
      departmentNotAdded: "Τμήμα δεν προστέθηκε",
      searchDepartnment: "Αναζήτηση κατά όνομα ή αριθμό τμήματος",
      addDepartMent: "Προσθήκη Τμήματος",
      addDepartment: "Προσθήκη Τμήματος",
      roleNameIsRequired: "Απαιτείται όνομα ρόλου",
      roleNameMustBeLessThan15Chars: "Το όνομα ρόλου πρέπει να είναι λιγότερο από 15 χαρακτήρες",
      roleAdded: "Προστέθηκε ρόλος",
      editDepartment: "Τμήμα Επεξεργασίας",
      departmentUpdated: "Ενημερώθηκε το Τμήμα",
      departmentNotUpdated: "Το Τμήμα δεν έχει ενημερωθεί",
      deleteDepartment: "Διαγραφή Τμήματος",
      deleteDepartmentMessage: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το τμήμα.",
      noRoleAvailable: "ΔΕΝ ΥΠΑΡΧΕΙ ΔΙΑΘΕΣΙΜΟΣ ΡΟΛΟΣ",
      roleUpdated: "Ενημερώθηκε ο ρόλος",
      roleNotUpdated: "Ο ρόλος δεν ενημερώθηκε",
      editRole: "Επεξεργασία ρόλου",
      allRole: "Όλος ο ρόλος",
      addNewRole: "Προσθήκη νέου ρόλου",
      allDepartment: "Όλο το Τμήμα",
      permissionsUpdated: "Τα δικαιώματα ενημερώθηκαν",
      permissionsnotUpdated: "Τα δικαιώματα δεν έχουν ενημερωθεί",
      roleNo: "Ρόλος Αρ.",
      searchByEmailAndName: "Αναζήτηση με email και όνομα",
      userID: "ταυτότητα χρήστη",
      userUpdated: "Ενημερώθηκε ο χρήστης",
      userNotUpdated: "Ο χρήστης δεν ενημερώθηκε",
      userAdded: "Προστέθηκε χρήστης",
      userNotAdded: "Ο χρήστης δεν προστέθηκε",
      activateUser: "Ενεργοποίηση χρήστη",
      deactivateUser: "Απενεργοποίηση χρήστη",
      userStatusMsg: "Είστε βέβαιοι ότι θέλετε να αλλάξετε την κατάσταση χρήστη",
      countryRequired: "Απαιτείται χώρα",
      stateRequired: "απαιτείται κράτος",
      cityRequired: "Η πόλη απαιτείται",
      searchByRole: "Αναζήτηση κατά αριθμό ρόλου, όνομα ρόλου, τμήμα",
      noModuleAvailable: "Δεν υπάρχει διαθέσιμη ενότητα",
      searchBYModuleName: "Αναζήτηση κατά όνομα ενότητας"
    },
    farm: {
      farmID: "Ταυτότητα αγροκτήματος",
      onTheFarm: "Στην φάρμα",
      userRoles: "Ρόλοι χρήστη",
      adduser: "Πρόσθεσε χρήστη",
      addAuser: "Προσθήκη χρήστη",
      uploadUsers: "Μεταφόρτωση χρηστών",
      addNewUser: "Προσθήκη νέου χρήστη",
      selectDept: "Επιλέξτε Τμήμα",
      selectRole: "Επιλέξτε Ρόλος",
      editUser: "Επεξεργασία χρήστη",
      totalFarms: "Total Farms",
      NoAnimalsRegisteredForthisFarm: "Κανένα ζώο δεν έχει εγγραφεί για αυτό το αγρόκτημα",
      farmsPerPage: "Αγροκτήματα ανά σελίδα",
      regularFarms: "Τακτικά αγροκτήματα",
      farmRegisteredProducts: "Προϊόντα Εγγεγραμμένα στη Φάρμα",
      searchByFarmNameAndId: "Αναζήτηση κατά όνομα και αναγνωριστικό αγροκτήματος",
      loadingProductsPleaseWait: "Φόρτωση προϊόντων... Περιμένετε",
      farmName: "Όνομα αγροκτήματος",
      farmLocation: "Τοποθεσία φάρμας",
      productName: "Ονομασία προϊόντος",
      stockStatus: "Κατάσταση μετοχών",
      inStock: "Σε απόθεμα",
      searchByProductName: "Αναζήτηση κατά όνομα προϊόντος",
      productCategory: "κατηγορία προιόντος",
      products: "Προϊόντα",
      farms: "Αγροκτήματα",
      registerAfarm: "Καταχωρίστε ένα αγρόκτημα",
      govtRegistry: "Κυβέρνηση ",
      cooperativeID: "Συνεταιριστική Ταυτότητα",
      farmType: "Τύπος αγροκτήματος",
      contractMating: "Συμβόλαιο ζευγάρωμα",
      customization: "Προσαρμογή",
      recordsPerpage: "Εγγραφές ανά σελίδα",
      restoreDefault: "Επαναφορά προεπιλογής",
      apply: "Ισχύουν",
      searchState: "Αναζήτηση κατά Ταυτότητα Αγροκτήματος, Μητρώο Κυβερνήτη, Ταυτότητα Συνεταιρισμού, Τύπος Φάρμας, Ζευγάρισμα συμβολαίου",
      farmOwner: "Ιδιοκτήτης φάρμας",
      govRegistrationNo: "Κυβερνητικός αριθμός μητρώου",
      farmInformation: "Πληροφορίες για το αγρόκτημα",
      ownershipType: "Τύπος ιδιοκτησίας",
      communityName: "Ονομα κοινότητας",
      farmLicenseInformation: "Πληροφορίες άδειας εκμετάλλευσης",
      licenseNumber: "ΑΡΙΘΜΟΣ ΑΔΕΙΑΣ",
      licenseExpiryDate: "Ημερομηνία λήξης άδειας",
      regulatorName: "Όνομα ρυθμιστή",
      regulatorRepresentativeName: "Όνομα αντιπροσώπου της ρυθμιστικής αρχής",
      farmLocationSize: "Τοποθεσία φάρμας",
      productionSystem: "Σύστημα παραγωγής",
      country: "Χώρα",
      state: "κατάσταση",
      city: "Πόλη",
      street: "Δρόμος",
      houseNumber: "Τον αριθμό του σπιτιού",
      farmRegistration: "Εγγραφή Αγροκτήματος",
      cancel: "Ματαίωση",
      register: "Κανω ΕΓΓΡΑΦΗ",
      ok: "Εντάξει",
      totalFarmSize: "Συνολικό μέγεθος αγροκτήματος",
      farmGeographicLocation: "Αγρόκτημα Γεωγραφική Τοποθεσία",
      perimeterPointLongitude: "Περιμετρικό Μήκος Σημείου",
      perimeterPointLatitude: "Περιμετρικό γεωγραφικό πλάτος",
      perimeterPointLabel: "Ετικέτα περιμετρικού σημείου",
      perimeterLength: "Μήκος Περιμέτρου",
      farmLatitude: "Farm Latitude",
      farmLongitude: "Γεωγραφικό μήκος αγροκτήματος",
      editFarm: "Επεξεργασία φάρμας",
      update: "Εκσυγχρονίζω",
      editAfarm: "Επεξεργαστείτε ένα αγρόκτημα",
      nextFarm: "Επόμενο Αγρόκτημα",
      nameoftheFarm: "Όνομα του αγροκτήματος",
      registerAProduct: " Εγγραφή προϊόντος",
      farmProducts: "Αγροτικά Προϊόντα",
      calf: "Μοσχάρι",
      steer: "Διευθύνω",
      heifer: "Αγελαδίτσα",
      sire: "Αρχοντας",
      dam: "Φράγμα",
      registerAnAnimal: "Εγγραφή ενός ζώου",
      farmAnimals: "Εκτρεφόμενα ζώα",
      farm_type: "Φάρμας τύπου",
      farm_Owner: "Αγρόκτημα",
      dateOfRegistration: "Ημερομηνία εγγραφής",
      dataIsNotAvailableForThisFarm: "Τα δεδομένα δεν είναι διαθέσιμα για αυτό το αγρόκτημα",
      registerNewProduct: "Εγγραφή Νέου Προϊόντος",
      information: "Πληροφορίες",
      licenseInfo: "Πληροφορίες άδειας χρήσης",
      locationInfo: "Πληροφορίες τοποθεσίας",
      geoLocation: "Γεωγραφική τοποθεσία",
      perimeterLengthState: "Μήκος περιμέτρου αγροκτημάτων (μήκος φράχτη)",
      totalFarmSizeState: "Μέγεθος ενός αγροκτήματος",
      productionSystemState: "Σύστημα Παραγωγής που χρησιμοποιείται στο Αγρόκτημα",
      contractMatingState: "Κώδικας Συμβολαίου Πρόγραμμα Ζευγαρώματος στο οποίο συμμετέχει η Φάρμα.",
      ownershipTypeState: "Είδος ιδιοκτησίας",
      regulatorRepresentativeNameState: "Όνομα του προσώπου που εκπροσωπεί τη ρυθμιστική αρχή που εξέδωσε την άδεια",
      regulatorNameState: "Όνομα της ρυθμιστικής αρχής που εξέδωσε την άδεια",
      licenseExpiryDateState: "Ημερομηνία κατά την οποία έχει λήξει η τρέχουσα άδεια χρήσης",
      licenseNumberState: "Αριθμός Άδειας Χρήσης που κυκλοφόρησε από τη Ρυθμιστική Αρχή",
      plotNumberState: "Αριθμός σπιτιού του αγροκτήματος.",
      plotNumber: "Αριθμός Σπίτι/Οικόπεδο",
      streetStatement: "Όνομα οδού του αγροκτήματος.",
      cityStatement: "Πόλη στην οποία βρίσκεται το αγρόκτημα.",
      stateStatement: "Περιοχή της χώρας στην οποία βρίσκεται το αγρόκτημα.",
      countryState: "Χώρα στην οποία βρίσκεται το αγρόκτημα.",
      perimeterPointLongitudeState: "Γεωγραφικό μήκος ενός σημείου στο αγρόκτημα.",
      perimeterPointLatitudeState: "Γεωγραφικό πλάτος ενός σημείου στο αγρόκτημα.",
      perimeterPointLabelState: "Ετικέτα του σημείου.",
      farmLongitudeState: "Γεωγραφικό μήκος του αγροκτήματος.",
      farmLatitudeState: "Γεωγραφικό πλάτος του αγροκτήματος.",
      farmNameH: "Όνομα αγροκτήματος",
      farmTypeH: "Ο τύπος του αγροκτήματος όπου πραγματοποιούνται διάφορες δραστηριότητες.",
      farmOwnerH: "Όνομα ιδιοκτήτη μιας φάρμας (αυτόματη δημιουργία ονόματος αγρότη με εισαγωγή πληροφοριών)",
      ownershipTypeH: "Το είδος των αγροτών που κατέχουν/ ελέγχουν τη γη που εκμεταλλεύονται και αυτών που δεν έχουν.",
      govtRegNumbH: "Αριθμός μητρώου του αγροκτήματος που εκχωρήθηκε από τη ρυθμιστική αρχή",
      contractMatingH: "Κώδικας συμβολαίου προγράμματος ζευγαρώματος στο οποίο συμμετέχει η φάρμα",
      productionSystemH: "Τι χρησιμοποιείται το σύστημα παραγωγής στο αγρόκτημα",
      cooperativeIDH: "Ταυτότητα συνεταιρισμού στον οποίο είναι μέλος το αγρόκτημα ",
      licenseNumberH: "Αριθμός αναγνώρισης σε μια άδεια που εκδόθηκε από τη ρυθμιστική αρχή που την προσδιορίζει με τον ιδιοκτήτη.",
      licenseExpiryDateH: "Ημερομηνία λήξης της τρέχουσας άδειας",
      regularNameH: "Όνομα της ρυθμιστικής αρχής που εξέδωσε την άδεια",
      regularRepName: "Όνομα του προσώπου που εκπροσωπεί τη ρυθμιστική αρχή που εξέδωσε την άδεια",
      countryH: "Χώρα στην οποία βρίσκεται το αγρόκτημα.",
      stateH: "Περιοχή της χώρας στην οποία βρίσκεται το αγρόκτημα.",
      cityH: "Πόλη στην οποία βρίσκεται το αγρόκτημα.",
      streetH: "Όνομα οδού του αγροκτήματος.",
      houseNumberH: "Αριθμός σπιτιού του αγροκτήματος.",
      totalFarmSizeH: "Το μέγεθος του αγροκτήματος είναι το άθροισμα της γης που καλλιεργείται επί του παρόντος από το αγρόκτημα, συμπεριλαμβανομένης της γης υπό αγρανάπαυση, αλλά εξαιρουμένης της γης με φυσική βλάστηση, δέντρα ή βοσκότοπους.",
      farmLatitudeH: "Είναι η μέτρηση της απόστασης βόρεια ή νότια του Ισημερινού. ",
      farmLongitudeH: "Μετρά την απόσταση ανατολικά ή δυτικά του πρώτου μεσημβρινού.",
      perimeterLengthH: "Μήκος περιμέτρου αγροκτημάτων (μήκος φράχτη)",
      perimeterPointLabelH: "Ετικέτα σημείου. ",
      perimeterPointLatH: "Γεωγραφικό πλάτος ενός σημείου στο αγρόκτημα",
      perimeterPointLongH: "Γεωγραφικό μήκος ενός σημείου στο αγρόκτημα",
      noProductAvailable: "Δεν υπάρχει διαθέσιμο προϊόν",
      farmUpdated: "Ενημερώθηκε το αγρόκτημα",
      performance: "Εκτέλεση",
      milkInformation: "Πληροφορίες για το γάλα",
      farmNameRequired: "Απαιτείται το όνομα της φάρμας"
    },
    login: {
      welcome: "Καλως ΗΡΘΑΤΕ! ",
      welInfo: "Εισαγάγετε τα διαπιστευτήριά σας.",
      login: "Σύνδεση",
      forgotPassword: "Ξεχάσατε τον κωδικό",
      forgotPasswordDesc: "Παρακαλώ, εισάγετε τη διεύθυνση ηλεκτρονικού ταχυδρομείου που σχετίζεται με το λογαριασμό σας. ",
      backToLogin: "Επιστροφή στην σελίδα εισόδου"
    },
    actionListmod: {
      actionList: "Λίστα ενεργειών",
      tODAY: "Σήμερα",
      createTask: "Δημιουργία Εργασίας",
      myActivities: "Οι Δραστηριότητές μου",
      jhonSmith: "Τζον Σμιθ",
      farmID: "Ταυτότητα αγροκτήματος",
      dateOfEvent: "Ημερομηνία εκδήλωσης",
      actionRequired: "Απαιτείται ενέργεια",
      actionTaken: "Έγινε δράση",
      animalEventID: "Αναγνωριστικό συμβάντος ζώου",
      cANCEL: "Ματαίωση",
      cONFIRM: "Επιβεβαιώνω",
      sTATEMENT: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εγγραφή;",
      dAY: "Ημέρα",
      wEEK: "Εβδομάδα",
      mONTH: "Μήνας",
      sUBMIT: "υποβάλλουν",
      startDate: "Ημερομηνία έναρξης",
      endDate: "Ημερομηνία λήξης",
      rEPEAT: "Επαναλαμβάνω",
      taskCategory: "Κατηγορία εργασιών",
      pRIORITY: "Προτεραιότητα",
      aSSIGNEE: "Εντολοδόχος",
      selectLocation: "Επιλέξτε τοποθεσία",
      selectAnimals: "Επιλέξτε ένα ή περισσότερα ζώα",
      dESCRIPTION: "Περιγραφή",
      customRecurrence: "Προσαρμοσμένη επανάληψη",
      repeatEvery: "Επαναλάβετε Κάθε",
      taskName: "Ονομα εργασίας",
      enterDescription: "Εισαγάγετε Περιγραφή",
      toDo: "Να κάνω",
      assignTo: "Εκχώρηση σε",
      status: "Κατάσταση",
      nOTE: "Σημείωση",
      noTaskAvailable: "ΔΕΝ ΥΠΑΡΧΕΙ ΔΙΑΘΕΣΙΜΗ ΕΡΓΑΣΙΑ",
      healthRecord: "Αρχείο Υγείας",
      iD: "ταυτότητα",
      tAG: "Ετικέτα",
      dateOfbirth: "Ημερομηνια γεννησης",
      taskTakenat: "Εργασία που λήφθηκε στο",
      gENDER: "Γένος",
      bREED: "Ράτσα",
      regDate: "Καν. ",
      updateHealthRecord: "Ενημέρωση αρχείου υγείας για ζώα",
      treatment: "Θεραπεία",
      reasonOftreatment: "Λόγος Θεραπείας",
      treatmentDate: "Ημερομηνία θεραπείας",
      dIAGNOSIS: "Διάγνωση",
      drugId: "Αναγνωριστικό φαρμάκου",
      drugName: "Όνομα φαρμάκου",
      drugWithdrawalperiod: "Περίοδος απόσυρσης φαρμάκου",
      attendingVeterinarian: "Παρακολούθηση Κτηνίατρου",
      packId: "Αναγνωριστικό πακέτου",
      noItemsselected: "Δεν επιλέχθηκαν αντικείμενα",
      healthRecordsubmission: "Υποβολή φακέλου υγείας",
      inseminationRecordsubmission: "γονιμοποίηση-Υποβολή αρχείου",
      inseminatorName: "Όνομα σπερματοδότη",
      inseminatorId: "Ιδ",
      conceptionRate: "Ποσοστό σύλληψης",
      dateOfmeasurement: "Ημερομηνία Μέτρησης",
      recordSubmission: "Υποβολή αρχείου",
      uPDATE: "Εκσυγχρονίζω",
      updateTask: "Ενημέρωση εργασίας"
    },
    inseminatorStatisticsInfo: {
      addInseminatorInfo: "Προσθήκη Inseminator Info",
      inseminatorNumber: "Αριθμός γονιμοποιητή",
      loadingInseminatorPleaseWait: "Φόρτωση Inseminator... Παρακαλώ περιμένετε",
      searchByIDAndName: "Αναζήτηση με ταυτότητα και όνομα",
      inseminatorInfoAdded: "Προστέθηκαν πληροφορίες για τον γονιμοποιητή",
      inseminatorInfoNotAdded: "Οι πληροφορίες Inseminator δεν προστέθηκαν",
      inseminatorInfoUpdated: "Ενημερώθηκαν οι πληροφορίες του Inseminator",
      inseminatorInfoNotUpdated: "Οι πληροφορίες Inseminator δεν ενημερώθηκαν",
      editAInseminatorInfo: "Επεξεργασία πληροφοριών Inseminator",
      inseminatorList: "Λίστα γονιμοποιητών",
      inseminatorInfoDetails: "Στοιχεία πληροφοριών Inseminator",
      updateInseminatorInfo: "Ενημέρωση Inseminator Info"
    },
    organizationNtrInfo: {
      loadingOrdersPleaseWait: "Φόρτωση παραγγελιών... Περιμένετε",
      addStocks: "Προσθήκη μετοχών",
      addStock: "Προσθήκη αποθέματος",
      quantity: "Ποσότητα",
      selectUnit: "Επιλέξτε Μονάδα",
      farmProducts: "Αγροτικά Προϊόντα",
      cost: "Κόστος",
      transactionID: "Ταυτότητα συναλλαγής",
      recipientID: "Αναγνωριστικό παραλήπτη",
      orderID: "Αριθμός Παραγγελίας",
      recepientName: "Όνομα Παραλήπτη",
      createAOrder: "Δημιουργήστε μια παραγγελία",
      totalStocks: "Σύνολο Αποθεμάτων",
      orders: "Παραγγελίες",
      totalPending: "Σύνολο σε εκκρεμότητα",
      totalDelivered: "Συνολική παράδοση",
      searchByRecepientNameOrderIdRecepientId: "Αναζήτηση κατά όνομα παραλήπτη, αναγνωριστικό παραγγελίας, αναγνωριστικό παραλήπτη",
      chooseTheDate: "Επιλέξτε την ημερομηνία",
      transactionDate: "Ημερομηνία Συναλλαγής",
      selectCategory: "Επιλέξτε Κατηγορία",
      volumeOfProduct: "Όγκος Προϊόντος",
      productQuantity: "Ποσότητα προϊόντος",
      productRecipientId: "Αναγνωριστικό παραλήπτη προϊόντος",
      productRecipientName: "Όνομα παραλήπτη προϊόντος",
      productRecipientType: "Τύπος παραλήπτη προϊόντος",
      singleProduct: "Ενιαίο Προϊόν",
      orderPlaced: "Ολοκλήρωση παραγγελίας",
      orderNotPlaced: "Η παραγγελία δεν πραγματοποιήθηκε",
      totalPrice: "Συνολικό ποσό",
      currency: "Νόμισμα",
      selectCurrency: "Επιλέξτε Νόμισμα",
      address: "Διεύθυνση",
      enterAddress: "Εισαγάγετε τη διεύθυνση",
      attachments: "Συνημμένα",
      chooseFile: "Επιλέξτε το αρχείο",
      nameOfTheFarm: "Όνομα του αγροκτήματος",
      loremIpsumHasBeenTheIndustrySStandardDummyText: "Το Lorem Ipsum είναι το τυπικό εικονικό κείμενο της βιομηχανίας από το 1500, όταν ένας άγνωστος εκτυπωτής πήρε ένα",
      billedTo: "Τιμολογήθηκε σε",
      orderStatus: "Κατάσταση παραγγελίας",
      selectStatus: "Επιλέξτε Κατάσταση",
      cadbury: "Cadbury",
      totalAmount: "Συνολικό ποσό",
      deliveryCharges: "Χρεώσεις παράδοσης",
      orderDetails: "Λεπτομέρειες Παραγγελίας",
      deliveryOnTime: "Παράδοση έγκαιρα",
      productID: "Αναγνωριστικό προϊόντος",
      productRegistration: "Καταχώρηση του προϊόντος",
      enterTheNameOfTheProduct: "Εισαγάγετε το όνομα του προϊόντος",
      nameOfTheProduct: "Όνομα του Προϊόντος",
      productAdded: "Προστέθηκε προϊόν",
      productNotAdded: "Το προϊόν δεν προστέθηκε"
    },
    drug: {
      dRUGS: "Φάρμακα",
      registerAdrug: "Καταχωρίστε ένα φάρμακο",
      sEARCH: "Αναζήτηση",
      genericName: "Γενικό Όνομα",
      manufacturer: "Κατασκευαστής",
      distributor: "Διανομέας",
      registrationDate: "Ημερομηνία Εγγραφής",
      drugRegistration: "Καταχώριση Φαρμάκων",
      drugInformation: "Πληροφορίες για τα φάρμακα",
      packExpiration: "Λήξη συσκευασίας",
      drugId: "Ταυτότητα φαρμάκου",
      drugName: "Όνομα φαρμάκου",
      drugGenericname: "Ονομασία γενόσημου φαρμάκου",
      drugManufacturer: "Φαρμακοποιός",
      distributorName: "Όνομα διανομέα",
      drugRegistrationdate: "Ημερομηνία Καταχώρισης Φαρμάκου",
      nextDrug: "Επόμενο Ναρκωτικό",
      editDrug: "Επεξεργασία φαρμάκου",
      updateDrug: "Ενημέρωση φαρμάκου",
      deleteDrug: "Διαγραφή Φαρμάκου",
      noRecordfound: "Δεν Βρέθηκε Αρχείο",
      addDrug: "Προσθήκη φαρμάκου",
      statementDrug: "Το φάρμακο έχει διαγραφεί.  ",
      cANCEL: "Ματαίωση",
      cONFIRM: "Επιβεβαιώνω",
      sTATEMENT: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εγγραφή;",
      ok: " Εντάξει",
      information: "Πληροφορίες",
      packOrder: "Παραγγελία πακέτου",
      packPrescription: "Συνταγή συσκευασίας",
      packReservation: "Κράτηση πακέτου",
      packLocation: "Τοποθεσία συσκευασίας",
      drugDozedam: "Δόση φαρμάκου σε μια μέρα για το φράγμα",
      drugDozecalf: "Δόση φαρμάκου σε μια μέρα για μοσχάρι",
      drugFormate: "Μορφή φαρμάκου",
      drugDistributor: "Διανομέας Φαρμάκων",
      drugActiveingridents: "Φαρμακευτικά Δραστικά Συστατικά",
      drugSubstitutionId: "Αναγν. αντικατάστασης φαρμάκου",
      packId: "Αναγνωριστικό πακέτου",
      packBatchNumber: "Αριθμός παρτίδας συσκευασίας",
      drugIdStatement: "Ο αριθμός παρτίδας του φαρμάκου.",
      drugNameSatement: "Η διαφημιζόμενη επωνυμία με την οποία πωλείται το φάρμακο.",
      drugGenericnameStatement: "Η χημική σύνθεση ενός φαρμάκου και όχι η διαφημιζόμενη επωνυμία με την οποία πωλείται το φάρμακο.",
      drugFormateSatement: "Ο αριθμός παρτίδας του φαρμάκου.",
      drugDozecalfSatement: "Να γνωρίζει την ποσότητα της δόσης του φαρμάκου στο μοσχάρι.",
      drugDozedamStatement: "Για να γνωρίζετε την ποσότητα της δόσης του φαρμάκου που θα δεσμευτεί.",
      drugManufacturerStatement: "Στοιχεία του κατασκευαστή του φαρμάκου.",
      drugDistributorStatement: "Στοιχεία του διανομέα ναρκωτικών.",
      drugRegistrationdateStatement: "Ημερομηνία καταχώρισης φαρμάκου στη συγκεκριμένη χώρα.",
      drugActiveingridentsStatement: "Κατάλογος των δραστικών συστατικών.",
      drugSubstitutionIdStatement: "Ταυτότητες πιθανών υποκαταστάσεων για το φάρμακο σε περίπτωση που το κύριο φάρμακο δεν είναι προς το παρόν διαθέσιμο.",
      packIdStatement: "Bar code ή RF ID της συσκευασίας.",
      packBatchNumberStatement: "Ο αριθμός παρτίδας που έχει εκχωρηθεί στη συσκευασία από τον κατασκευαστή.",
      locationWarehouseID: "Αναγνωριστικό αποθήκης τοποθεσίας",
      locationWarehouseIDState: "Ταυτότητα της αποθήκης όπου φυλάσσεται το πακέτο.",
      locationRackID: "Τοποθεσία Rack ID",
      locationRackIDStatement: "Αναγνωριστικό του ράφι όπου είναι αποθηκευμένο το πακέτο.",
      locationTierID: "Αναγνωριστικό επιπέδου τοποθεσίας",
      locationTierIDStatement: "Αναγνωριστικό της βαθμίδας στο ράφι όπου είναι αποθηκευμένο το πακέτο.",
      locationPositionID: "Αναγνωριστικό θέσης τοποθεσίας",
      locationPositionIDStatement: "Αναγνωριστικό της θέσης σε ένα επίπεδο όπου είναι αποθηκευμένο το πακέτο.",
      storageTemperatureCondition: "Κατάσταση θερμοκρασίας αποθήκευσης",
      storageTemperatureConditionStats: "Κατάσταση αποθήκευσης της συσκευασίας.",
      containerForm: "Φόρμα δοχείου",
      containerFormStatement: "Μορφή δοχείου στο οποίο ήταν συσκευασμένο το φάρμακο.",
      consistQuantity: "Σύνθεση Ποσότητα",
      consistQuantityStatement: "Ποσότητα χαπιών, μπουκαλιών κ.λπ. στη συσκευασία.",
      releaseId: "Αναγνωριστικό έκδοσης",
      releaseIdStatement: "Ταυτότητα που εκχωρείται μετά τη λήψη του πακέτου από τον αγρότη.",
      releaseDate: "Ημερομηνία κυκλοφορίας",
      releaseDateStatement: "Ημερομηνία λήψης της συσκευασίας από το απόθεμα από τον αγρότη.",
      packManufacturedDate: "Συσκευασία Ημερομηνία κατασκευής",
      packManufacturedDateStatement: "Ημερομηνία κατασκευής της συσκευασίας.",
      packImportedDate: "Ημερομηνία εισαγωγής συσκευασίας",
      packImportedDateStatement: "Ημερομηνία εισαγωγής της συσκευασίας.",
      packExpirationDate: "Ημερομηνία λήξης συσκευασίας",
      packExpirationDateStatement: "Ημερομηνία λήξης της συσκευασίας.",
      expiredSoonFlag: "Σημαία που έληξε σύντομα",
      expiredSoonFlagState: "Προειδοποίηση για τη λήξη της συσκευασίας σύντομα.",
      packTotalVolumeLeft: "Απομένει Συνολικός όγκος συσκευασίας",
      packTotalVolumeLeftState: "Συνολικός αριθμός συσκευασιών με τα ίδια συστατικά που έχουν απομείνει στο απόθεμα.",
      packOrderID: "Αναγνωριστικό παραγγελίας πακέτου",
      packOrderIDState: "Ταυτότητα που εκχωρήθηκε μετά την παραγγελία του πακέτου από τον διανομέα.",
      packQuantityOrdered: "Ποσότητα συσκευασίας Παραγγελθείσα",
      packQuantityOrderedState: "Αριθμός συσκευασιών που παραγγέλθηκαν από τον διανομέα.",
      packPrice: "Τιμή πακέτου",
      packPriceStatement: "Τιμή συσκευασίας.",
      priceCurrency: "Τιμή Νόμισμα",
      packPricecurrency: "Τιμή πακέτου Νόμισμα",
      packPricecurrencyState: "Όνομα νομίσματος στο οποίο ορίζεται η τιμή.",
      packPaydate: "Ημερομηνία πληρωμής πακέτου",
      payDate: "Ημερομηνία πληρωμής",
      packPaydateState: "Ημερομηνία κατά την οποία αποδόθηκε η πληρωμή στον διανομέα.",
      packShippingID: "Ταυτότητα αποστολής πακέτου",
      shippingID: "Ταυτότητα αποστολής",
      packShippingIdState: "Αναγνωριστικό αποστολής του πακέτου όταν φτάσει από τον διανομέα.",
      packShippingDate: "Ημερομηνία αποστολής πακέτου",
      shippingDate: "Ημερομηνία αποστολής",
      packShippingDateState: "Ημερομηνία άφιξης της συσκευασίας στο απόθεμα.",
      packOrderStatus: "Κατάσταση παραγγελίας πακέτου",
      packOrderStatusState: "Κατάσταση της τρέχουσας παραγγελίας.",
      recepientKeeperId: "Αναγνωριστικό φύλακα παραλήπτη",
      recepientKeeperIdStatement: "Το όνομα του ατόμου/οργανισμού που έλαβε το πακέτο.",
      recepientFarmId: "Αναγνωριστικό φάρμας παραλήπτη",
      recepientFarmIdStatement: "Ταυτότητα της φάρμας στην οποία ανήκει η παραλαβή ναρκωτικών ζώων.",
      recepientAnimalId: "Αναγνωριστικό ζώου παραλήπτη",
      recepientAnimalIdState: "Ταυτότητα του ζώου στο οποίο συνταγογραφήθηκε το φάρμακο (συσκευασία).",
      specialistComments: "Σχόλια ειδικών",
      specialistCommentsState: "Σχόλια ειδικού/κτηνιατρικού για τη συνταγογράφηση.",
      specialistName: "Όνομα ειδικού",
      specialistNameState: "Όνομα του ειδικού/κτηνιατρού που συνταγογράφησε το φάρμακο.",
      specialistID: "Ταυτότητα ειδικού",
      specialistIDState: "Ταυτότητα του ειδικού/κτηνιατρού που συνταγογράφησε το φάρμακο.",
      reservedByKeeperId: "Κράτηση από Keeper Id",
      reservedByKeeperIdState: "Αναγνωριστικό κατόχου για το ποιος έκανε κράτηση για το πακέτο.",
      reservedByFarmId: "Reserved By Farm Id",
      reservedByFarmIdState: "Αναγνωριστικό αγροκτήματος για το οποίο δεσμεύτηκε το πακέτο.",
      reservationTimeoutDate: "Ημερομηνία λήξης χρονικού ορίου κράτησης",
      reservationTimeoutDateState: "Ημερομηνία κατά την οποία η κράτηση θα ακυρωθεί αυτόματα εάν δεν αγοραστεί το πακέτο.",
      reservationTimeout: "Χρονικό όριο κράτησης",
      reservationTimeoutState: "Αριθμός ωρών μετά τις οποίες η κράτηση θα ακυρωθεί αυτόματα εάν το πακέτο δεν αγοραστεί ή παραληφθεί",
      reservationDate: "Ημερομηνία κράτησης",
      reservationDateState: "Ημερομηνία κράτησης του πακέτου.",
      reservationStatus: "Κατάσταση κράτησης",
      reservationStatusState: "Κατάσταση της κράτησης πακέτου. ",
      loadingDrugsPleaseWait: "Φόρτωση Ναρκωτικών... Περιμένετε",
      quantityOrder: "Ποσότητα παραγγελίας",
      keeperID: "Ταυτότητα φύλακα",
      timeoutDate: "Ημερομηνία χρονικού ορίου",
      warehouseID: "Ταυτότητα αποθήκης",
      rackID: "Αναγνωριστικό rack",
      tierID: "Ταυτότητα επιπέδου",
      positionID: "Ταυτότητα θέσης",
      temperatureCondition: "Θερμοκρασία Κατάσταση",
      manufactureDate: "Ημερομηνία παραγωγής",
      importedDate: "Ημερομηνία εισαγωγής",
      totalVolumeLeft: "Συνολικός όγκος που απομένει"
    },
    reports: {
      myReports: "Οι αναφορές μου",
      satelliteReports: "Δορυφορικές αναφορές",
      weatherReports: "Δελτία καιρού",
      pregnancyAnalytics: "Αναλύσεις εγκυμοσύνης",
      semenEmbroyAnalytics: "Semen/Embroy Analytics",
      semenAnalytics: "Semen Analytics",
      embryoAnalytics: "Embryo Analytics",
      calfAnalytics: "Calf Analytics",
      milkProduction: "Παραγωγή γάλακτος",
      totalMilkType: "Ολικός τύπος γάλακτος",
      totalAnimalAnalytics: "Σύνολο Animal Analytics",
      animalAnalytics: "Animal Analytics",
      analyticsAndReporting: "Αναλύσεις και Αναφορές",
      filterByCountry: "Φιλτράρισμα κατά χώρα",
      filterByFarm: "Φιλτράρισμα κατά αγρόκτημα",
      filterByRegion: "Φιλτράρισμα κατά περιοχή",
      filterByMonth: "Φιλτράρισμα ανά μήνα",
      filterByDate: "Φιλτράρισμα κατά ημερομηνία",
      filterByRole: "Φιλτράρισμα κατά ρόλο",
      filterByYear: "Φιλτράρισμα ανά έτος",
      filterByTrait: "Φιλτράρισμα κατά χαρακτηριστικό",
      avgBreedingValue: "Μέση Αναπαραγωγική Αξία",
      avgEconomicIndex: "Μέσος Οικονομικός Δείκτης",
      breederReport: "Έκθεση Breeder",
      semenTransferDate: "Ημερομηνία Μεταφοράς Σπέρματος",
      semenEmbryoProductionReport: "Έκθεση παραγωγής σπέρματος/εμβρύου",
      semenProducts: "Προϊόντα σπέρματος",
      meatProducts: "Προϊόντα Κρέατος",
      totalProducts: "Σύνολο προϊόντων",
      semenEmbryoReport: "Έκθεση Σπέρματος/Εμβρύου",
      numOfStraws: "Αριθμός Καλαμιών",
      collectionDate: "Ημερομηνία συλλογής",
      productionReport: "Έκθεση Παραγωγής",
      receipientId: "Ταυτότητα παραλήπτη",
      embryoId: "Ταυτότητα εμβρύου",
      semenStrawId: "Ταυτότητα άχυρου σπέρματος",
      dataScientist: "Επιστήμονας Δεδομένων",
      dataScientistReport: "Έκθεση Επιστήμονα Δεδομένων",
      productReport: "Αναφορά προϊόντος",
      dairyProducts: "γαλακτοκομικά προϊόντα"
    },
    genoPerformance: {
      performanceOfGenoType: "Performance Of GenoType",
      addAGenoType: "Προσθήκη GenoType",
      breedName: "Όνομα φυλής",
      chromosome: "Χρωμόσωμα",
      sequenceChange: "Αλλαγή ακολουθίας",
      inheritance: "Κληρονομία",
      diseaseName: "Όνομα ασθένειας",
      referenceSequence: "Ακολουθία αναφοράς",
      pubmedReference: "Δημοσιευμένη αναφορά",
      genoTypeRegistration: "Εγγραφή Γονοτύπου",
      breed: "Ράτσα",
      editAGenoType: "Επεξεργασία ενός GenoType",
      editGenoType: "Επεξεργασία GenoType",
      loadingGene: "Φόρτωση Geno... Περιμένετε",
      geneTypeList: "Λίστα GenoType"
    },
    reportings: {
      conception: "Σύλληψη (Επιστήμονας Δεδομένων)",
      performanceOfGenoData: "Performance of Genotype (Data Scientist)",
      totalInsemination: "Ολική γονιμοποίηση",
      embryo: "Εμβρυο",
      animalVaccinationRecord: "Αρχείο εμβολιασμού ζώων",
      dataNotAvailable: "Τα δεδομένα δεν είναι διαθέσιμα για αυτό το αγρόκτημα.",
      pregnancyStatus: "Κατάσταση Εγκυμοσύνης",
      healthReport: "Έκθεση Υγείας",
      heavyMilk: "Βαρύ γάλα",
      standardMilk: "Τυποποιημένο γάλα"
    },
    sidebar: {
      healthAnalytics: "Αναλύσεις υγείας",
      productionAnalytics: "Αναλύσεις Παραγωγής"
    },
    epd: {
      regNo: "Το Animal Reg No είναι ο μοναδικός κωδικός που δίνεται στο ζώο χρησιμοποιώντας ένα μέσο σήμανσης, διασφαλίζοντας μια διαδικασία για τον εντοπισμό και την παρακολούθηση συγκεκριμένων ζώων",
      internationalID: "Διεθνής Ταυτότητα Ζώου",
      location: "Χώρα / Περιοχή Γέννησης Ζώου ",
      animalName: "Τυπική ονομασία / Ονοματολογία του ζώου",
      gender: "Φύλο του ζώου (αρσενικό/θηλυκό)",
      additionalIDMethod: "Ποια μέθοδος χρησιμοποιήθηκε για την αναγνώριση του ζώου (π.χ. αυτί, τατουάζ)",
      damID: "ID ή αριθμός μητρώου φράγματος ζώου-ο θηλυκός γονέας ζώου/Αριθμός ταυτότητας της βιολογικής μητέρας",
      sireId: "Ταυτότητα ή αριθμός μητρώου του αρσενικού γονέα ενός ζώου, ειδικά ενός ταύρου που φυλάσσεται για αναπαραγωγή ή σπέρματος ταύρου που χρησιμοποιείται για τεχνητή γονιμοποίηση.",
      dateOfBirth: "Ημερομηνία γέννησης του ζώου.",
      breederHerdCode: "Κωδικός αγέλης κτηνοτρόφων ως επί το πλείστον από Ενώσεις Εκτροφέων",
      seasonofBirth: "Season of Birth of Animal σημειώνεται κατά μήνα",
      birthYear: "Η χρονιά που γεννήθηκε το ζώο",
      birthManagementCode: "Κωδικός διαχείρισης γεννήσεων παρέχεται κυρίως από χρήστη/αγρότη",
      birthSex: "Φύλο του ζώου (αρσενικό/θηλυκό)",
      birthWeight: "Βάρος γέννησης μοσχαριού ",
      primaryBreed: "Κύριο % Γενετική συμβολή του ζώου ",
      secondaryBreed: "Μικρό % Γενετική συμβολή του ζώου ",
      breedComposition: "Το ποσοστό σύνθεσης φυλής αναφέρεται στην αναλογική αναπαράσταση διαφορετικών φυλών στη γενετική σύνθεση ενός μεμονωμένου ζώου ή μιας ομάδας ζώων. ",
      conceptionMethod: "Πώς συνελήφθη το ζώο (φυσικό ζευγάρωμα/γονιμοποίηση/εμβρυομεταφορά).",
      accuracyWeight: "Ακρίβεια Βάρος",
      damAge: "Η ηλικία του φράγματος σε μήνες/χρόνια π.χ. ",
      weaningWeight: "Απογαλακτισμός Βάρος ζώου τη στιγμή του απογαλακτισμού.",
      weaningDate: "Η ημερομηνία κατά την οποία το ζώο απογαλακτίστηκε",
      weaningSex: "Το φύλο του ζώου που απογαλακτίστηκε. ",
      managementPastureCode: "Κωδικός που δίνεται στη διαχείριση/βοσκότοποι από χρήστη/αγρότη ",
      creep: "Η σίτιση ερπυσμού είναι η πρακτική της παροχής συμπληρωματικής τροφής (σιτηρών ή χορτονομής) σε μόσχους που θηλάζουν.",
      weaningContemporaryGroupCode: "Code of Weaning Weight Contemporary Group",
      birthContemporaryCode: "Γέννηση Σύγχρονος Κώδικας",
      yearlingDate: "Ημερομηνία ζώου ηλικίας ενός έτους ή στο δεύτερο έτος της ηλικίας του",
      managementFeedUnitCode: "Κωδικός που δίνεται στη μονάδα διαχείρισης/τροφοδοσίας ανά χρήστη",
      yearlingSex: "Το φύλο του ζώου την εποχή του έτους ",
      yearlingWeight: "Το ετήσιο βάρος είναι μια μέτρηση της άμεσης ανάπτυξης μετά τον απογαλακτισμό και χρησιμοποιείται συχνά για να αντικατοπτρίζει την πιθανή απόδοση των απογόνων που συνδέονται με την αγορά στην τροφή, μετρούμενη σε λίβρες μόσχου.",
      yearlingHeight: "Ύψος του ζώου την εποχή του έτους ",
      yearlingWeightContemporaryGroupCode: "Code of Yearling Weight Contemporary Group",
      weaningYearlingWeightContemporaryGroupCode: "κωδικός Weaning or Yearling Weight Contemporary Group",
      daysOnFeed: "Αριθμός ημερών που τρέφονται με τη συγκεκριμένη τροφή Παράδειγμα: τα νεαρά βοοειδή που αναπτύσσονται τρέφονται με δίαιτα υψηλής ενέργειας για την παραγωγή εμπορεύσιμου βοείου κρέατος με χαμηλό κόστος κέρδους. ",
      managementFeedUnitPenCode: "Κωδικός που δίνεται στη διαχείριση/μονάδα τροφοδοσίας/στυλό ανά χρήστη",
      harvestDate: "Ημερομηνία σφαγής (θανάτωσης) για κρέας",
      gradingDate: "Η ημερομηνία των σφαγίων ταξινομήθηκε σύμφωνα με συγκεκριμένα κριτήρια",
      carcassSex: "Το φύλο του σφαγίου",
      dateonFeed: "Ημερομηνία μετακίνησης του ζώου σε νέα τροφή Π.χ.: τα νεαρά αναπτυσσόμενα βοοειδή τρέφονται με δίαιτα υψηλής ενέργειας για την παραγωγή εμπορεύσιμου βοείου κρέατος με χαμηλό κόστος κέρδους. ",
      KPH: "% KPH είναι το ποσοστό του συνολικού λίπους που βρίσκεται στην σωματική κοιλότητα ενός πτώματος ειδικά στις περιοχές των νεφρών, της λεκάνης και της καρδιάς. ",
      carcassWeight: "Το βάρος του σφάγιου είναι το θερμό ή μη παγωμένο βάρος μετά τη συγκομιδή και την αφαίρεση του δέρματος, της κεφαλής, του γαστρεντερικού σωλήνα και των εσωτερικών οργάνων. ",
      fatThickness: "Το πάχος του λίπους μετριέται σε ίντσες χρησιμοποιώντας ένα μικρό χάρακα. ",
      marbling: "Το μάρμαρο είναι το ορατό ακόρεστο (υγιές) ενδομυϊκό λίπος που συσσωρεύεται εντός του μυός και μεταξύ των δεσμών των μυϊκών ινών.",
      ribeyeArea: "Ποσότητα της περιοχής των πλευρών του ματιού (οσφυϊκός ή ραχιαίος μυς longissimus dorsi) που μετράται μεταξύ της 12ης και της 13ης πλευράς σε τετραγωνικές ίντσες χρησιμοποιώντας ένα πλέγμα (π.χ., 8, 9 ή 10 ίντσες). ",
      animalStatus: "Κατάσταση ζώου στο αγρόκτημα π.χ.: υγιές, άρρωστο κ.λπ"
    },
    manageAnimalGroupings: {
      resetModeTooltip: "\n        RESET MODE <br>\n            Σε αυτή τη λειτουργία <br>\n            1) Ορίστε/καθορίστε όλα τα χαρακτηριστικά των σύγχρονων ομάδων (CG) για όλα τα χαρακτηριστικά ενδιαφέροντος. <br>\n            2) Αντιστοιχίστε όλα τα ζώα σε ένα αντίστοιχο CG. <br>\n            3) Εάν η αντιστοίχιση των ζώων δεν είναι ικανοποιητική, προσαρμόστε/αλλάξτε τα CG και στη συνέχεια εκχωρήστε ξανά τα ζώα στα νέα αντίστοιχα CG. <br>\n            4) Επαναλάβετε τα παραπάνω βήματα, εάν είναι απαραίτητο, μέχρι να είστε ικανοποιημένοι με τα CG και την αντίστοιχη ομαδοποίηση/καταχώρηση των ζώων.<br>\n        ",
      maintainanceModeHeadingTooltip: "Μόλις οριστικοποιηθεί η ΕΠΑΝΑΦΟΡΑ (λειτουργία), θα εισέλθετε στη ΛΕΙΤΟΥΡΓΙΑ ΣΥΝΤΗΡΗΣΗΣ όπου τα EDP που υπολογίζονται στο RESET θα διατηρηθούν σταθερά για κάθε ζώο μέχρι το επόμενο RESET (το οποίο μπορεί να απέχει 2-6 μήνες). ",
      maintainanceModeTooltip: "Μετά την ολοκλήρωση του RESET MODE, πατήστε το κουμπί RESET FINALIZED για να μπορέσει το σύστημα να υπολογίσει τα EPD όλων των ζώων, να τερματίσει τη λειτουργία RESET και να ξεκινήσει τη λειτουργία MAINTENANCE.",
      resetToggleTooltip: "Ενεργοποιήστε το Reset Toggle στη ρύθμιση μοντέλου EPD για να εκχωρήσετε ζώα σε CG."
    },
    geneticsAndBreeding: {
      geneticsAndBreeding: "Γενεσιολογία",
      geneticSearchTool: "Εργαλείο γενετικής αναζήτησης",
      dataSubmission: "Υποβολή Δεδομένων / Επιλογή Ζώου",
      animalsWithExpectedProgenyDifferences: "Υπολογισμός επιλογής ζώων για αναμενόμενες διαφορές απογόνων (EPD).",
      searchByAnimalIdName: "Αναζήτηση ανά αναγνωριστικό ζώου, όνομα",
      rowsPerPage: "Σειρές ανά σελίδα",
      individualEntry: "Ατομική Είσοδος",
      bulkEntry: "Μαζική Είσοδος",
      registerANewAnimalOrSelectAnExistingAnimal: "Καταχωρίστε ένα νέο ζώο ή επιλέξτε ένα υπάρχον ζώο.",
      registerNewAnimal: "Εγγραφή Νέου Ζώου",
      selectExistingAnimal: "Επιλέξτε Υπάρχον ζώο",
      animalID: "Ταυτότητα ζώου",
      animalName: "Όνομα Ζώου",
      tag: "Ετικέτα",
      dateOfBirth: "Ημερομηνια γεννησης",
      gender: "Γένος",
      birthDate: "Ημερομηνία γέννησης",
      birthWeightLb: "Βάρος γέννησης (lb)",
      birthWeightKg: "Βάρος γέννησης (kg)",
      weaningWeightLb: "Βάρος απογαλακτισμού (λίβρες)",
      weaningWeightKg: "Βάρος απογαλακτισμού (kg)",
      yearlingWeightLb: "Ετήσιο βάρος (lb)",
      yearlingWeightKg: "Ετήσιο βάρος (kg)",
      carcassWeightLb: "Βάρος σφαγίου (λίβρες)",
      carcassWeightKg: "Βάρος σφάγιου (kg)",
      animalSelection: "Επιλογή Ζώου",
      animalSearchTool: "Εργαλείο αναζήτησης ζώων",
      back: "Πίσω",
      searchByEPDs: "Αναζήτηση κατά EPD",
      searchByIds: "Αναζήτηση κατά αναγνωριστικά",
      selectBreed: "Επιλέξτε Φυλή",
      selectGender: "Επιλέξτε γένος",
      selectRequiredBreedForCattle: "Επιλέξτε Απαιτούμενη φυλή για βοοειδή",
      resetFilter: "ΕΠΑΝΑΦΟΡΑ ΦΙΛΤΡΟΥ",
      birthWeightHeader: "Βάρος γέννησης (BW): ",
      birthWeightDef: "Συγκρίνει τις διαφορές στο βάρος των μοσχαριών κατά τη γέννηση και μετριέται σε λίβρες ή κιλά.",
      weaningWeightHeader: "Βάρος απογαλακτισμού (WW): ",
      weaningWeightDef: "Το WW EPD είναι μια εκτίμηση της ανάπτυξης πριν από τον απογαλακτισμό που μετράται σε λίβρες ή κιλά.",
      yearlingWeightHeader: "Ετήσιο Βάρος (YW): ",
      yearlingWeightDef: "Το YW EPD είναι μια εκτίμηση της ανάπτυξης μετά τον απογαλακτισμό που μετράται σε λίβρες ή κιλά.",
      ribEyeAreaHeader: "Περιοχή Ribeye (REA): ",
      ribEyeAreaDef: "Το REA μετρά το μέγεθος του μυός που μας δίνει το ribeye σε τετραγωνικές ίντσες. Τα EPDs REA αντικατοπτρίζουν τις διαφορές σε μια προσαρμοσμένη μέτρηση της περιοχής ribeye 365 ημερών με βάση τις μετρήσεις σφαγίου βοοειδών που έχουν συγκομιστεί.",
      marblingHeader: "Μαρμάρισμα (MARB): ",
      marblingDef: "Το MARB EPD είναι σε μονάδες ποσοστού ενδομυϊκού λίπους εντός του ribeye. Τα MARB EPD αντικατοπτρίζουν διαφορές σε μια προσαρμοσμένη βαθμολογία μαρμάρωσης 365 ημερών (ενδομυϊκό λίπος, [IMF]) με βάση τις μετρήσεις σφαγίου βοοειδών που έχουν συγκομιστεί.",
      fatThicknessHeader: "Πάχος λίπους (FAT): ",
      fatThicknessDef: "Οι ίντσες λίπους (σε εκατοστά της ίντσας) είναι η μονάδα μέτρησης για το FT.",
      carcassWeightHeader: "Βάρος σφαγίου (CW): ",
      carcassWeightDef: "Το βάρος του σφάγιου είναι ένα ευεργετικό χαρακτηριστικό όταν λαμβάνεται υπόψη ο αντίκτυπος που έχουν οι λίρες σε σχέση με την αξία του τελικού προϊόντος. ",
      yieldGradeHeader: "Βαθμός απόδοσης (YG): ",
      yieldGradeDef: "Το σύστημα βαθμολόγησης του USDA Yield Grade είναι η μονάδα μέτρησης για το YG EPD. ",
      milkHeader: "Γάλα (MK): ",
      milkDef: "Το MK EPD μετριέται σε κιλά βάρους απογαλακτισμού μόσχου λόγω της ικανότητας αρμέγματος της μητέρας του.",
      totalMaternalHeader: "Σύνολο μητρικής(TM): ",
      totalMaternalDef: "Το TM μετρά τον αντίκτυπο στο βάρος απογαλακτισμού μόσχου λόγω τόσο της παραγωγής γάλακτος όσο και της γενετικής ανάπτυξης της αγελάδας.",
      calvingEaseDirectHeader: "Απευθείας τοκετός (CED): ",
      calvingEaseDirectDef: "Το CED EPD αναφέρεται ως ποσοστό μη υποβοηθούμενων τοκετών.",
      calvingEaseMaternalHeader: "Calving Ease Maternal (CEM): ",
      calvingEaseMaternalDef: "Μετρά την ικανότητα των κορών ενός ταύρου να γεννούν χωρίς βοήθεια ως δύο ετών.",
      stayabilityHeader: "Stayability (STAY): ",
      stayabilityDef: "Το ST EPD προβλέπει την ικανότητα ενός ταύρου να γεννά αγελάδες που «μένουν τριγύρω». ",
      docilityHeader: "Υποταγή (DOC): ",
      docilityDef: "Το DOC μετρά την ιδιοσυγκρασία των βοοειδών.",
      max: "ΜΕΓΙΣΤΗ",
      min: "MIN",
      accuracy: "ΑΚΡΙΒΕΙΑ",
      sortBy: "Ταξινόμηση κατά",
      traits: "Τα χαρακτηριστικά που εμφανίζονται με γκρι είναι υπό ανάπτυξη και θα κυκλοφορήσουν το 2ο τρίμηνο του 2023.",
      searchResults: "Αποτελέσματα αναζήτησης",
      recordsFound: "βρέθηκαν αρχεία",
      compareSelected: "ΣΥΓΚΡΙΣΗ ΕΠΙΛΕΓΜΕΝΩΝ",
      animalIdentification: "Ταυτοποίηση Ζώου",
      errorMessage: {
        birthWeight: "Η μέγιστη τιμή του βάρους γέννησης δεν μπορεί να είναι μικρότερη από το ελάχιστο βάρος γέννησης",
        weaningWeight: "Η μέγιστη τιμή βάρους απογαλακτισμού δεν μπορεί να είναι μικρότερη από το ελάχιστο βάρος απογαλακτισμού",
        yearlingWeight: "Η μέγιστη τιμή για το ετήσιο βάρος δεν μπορεί να είναι μικρότερη από το ελάχιστο βάρος ενός έτους",
        carcassWeight: "Η μέγιστη τιμή βάρους σφαγίου δεν μπορεί να είναι μικρότερη από το ελάχιστο βάρος γέννησης",
        fatThickness: "Η μέγιστη τιμή πάχους λίπους δεν μπορεί να είναι μικρότερη από το ελάχιστο βάρος απογαλακτισμού",
        marbling: "Η μέγιστη τιμή μαρμάρωσης δεν μπορεί να είναι μικρότερη από το ελάχιστο βάρος ενός έτους",
        ribeyeArea: "Η μέγιστη τιμή της περιοχής Ribeye δεν μπορεί να είναι μικρότερη από το ελάχιστο βάρος γέννησης",
        yieldGrade: "Η μέγιστη τιμή του βαθμού απόδοσης δεν μπορεί να είναι μικρότερη από το ελάχιστο βάρος απογαλακτισμού",
        milk: "Η μέγιστη τιμή του γάλακτος δεν μπορεί να είναι μικρότερη από το ελάχιστο βάρος απογαλακτισμού"
      },
      reg: "Καν",
      name: "Ονομα",
      sex: "Φύλο",
      tattoo: "Τατουάζ",
      dob: "DOB",
      EPD: "EPD",
      rank: "Τάξη",
      searchValue: "Τιμή αναζήτησης",
      typeHere: "Πληκτρολογίστε εδώ",
      searching: "Ερευνητικός...",
      fetchingResult: "Λήψη αποτελεσμάτων...Παρακαλώ περιμένετε",
      animalsMatchedYourCriteria: "Τα ζώα ταιριάζουν με τα κριτήριά σας",
      manageAnimalsGrouping: "Διαχείριση Ομαδοποίησης Ζώων",
      manageAnimalGroupings: "Διαχείριση Ομάδων Ζώων",
      assignAnimalToContemporaryGroups: "Αναθέστε ζώα σε σύγχρονες ομάδες",
      resetMode: "Λειτουργία επαναφοράς",
      enterResetMode: "Μπείτε στη λειτουργία επαναφοράς",
      maintainanceMode: "Λειτουργία συντήρησης",
      assigningAnimals: "Ανάθεση ζώων",
      excludedAnimals: "Εξαιρούμενα Ζώα",
      ungroupedAnimals: "Μη ομαδοποιημένα ζώα",
      assignAnimalsToCGS: "Αναθέστε ζώα στο CGS",
      reset: "Επαναφορά",
      excludeAnimals: "Εξαιρούνται τα ζώα",
      resetToMaintainanceMode: "Ολοκληρώθηκε η επαναφορά - Αλλαγή σε λειτουργία συντήρησης",
      contemporaryGroupsSettings: "Ρυθμίσεις Contemporary Groups (CG).",
      selectTrait: "Επιλέξτε Χαρακτηριστικό",
      selectTraitDescription: "Το Select Trait αναφέρεται στη διαδικασία επιλογής ενός συγκεκριμένου χαρακτηριστικού",
      traitsType: {
        birthWeight: "Βάρος γέννησης",
        weaningWeight: "Βάρος απογαλακτισμού",
        yearlingWeight: "Ετήσιο βάρος",
        carcassWeight: "Βάρος σφαγίου"
      },
      addNewGroup: "ΠΡΟΣΘΗΚΗ ΝΕΑΣ ΟΜΑΔΑΣ",
      contemporaryGroup: "Σύγχρονη Ομάδα",
      contemporaryGroups: "Σύγχρονες Ομάδες",
      editGroup: "Επεξεργασία ομάδας",
      birthCGCode: "Κωδικός Γέννησης (CG).",
      groupName: "Ονομα ομάδας",
      birthSex: "Φύλο γέννησης",
      conceptionMethod: "Μέθοδος Σύλληψης",
      weaningCGCode: "Κωδικός απογαλακτισμού (CG).",
      yearlingCGCode: "Κωδικός Yearling(CG).",
      dateWeight: "Βάρος ημερομηνίας",
      weaningyearlingCGcode: "Κωδικός Απογαλακτισμού/Έτησης (CG).",
      carcassCGCode: "Κωδικός Carcas (CG).",
      breedOfDom: "Breed of Dam",
      addNewContemporaryGroup: "Προσθήκη Νέας Σύγχρονης Ομάδας",
      createNewGroup: "Δημιουργία νέας ομάδας",
      selectFromDifferentTraits: "Επιλέξτε από διαφορετικά χαρακτηριστικά",
      contemporaryGroupName: "Σύγχρονο Όνομα Ομάδας",
      enterNameHere: "Εισαγάγετε το όνομα εδώ",
      groupNameIsRequired: "Απαιτείται όνομα ομάδας",
      birthYearRange: "Εύρος έτους γέννησης",
      theYearAnimalWasBorn: "Η χρονιά που γεννήθηκε το ζώο",
      birthYearIsRequired: "Απαιτείται έτος γέννησης",
      genderOfNewBornAnimal: "Φύλο νεογέννητου ζώου",
      selectSex: "Επιλέξτε Φύλο",
      theweightOfAnimalAtBirth: "Το βάρος του ζώου κατά τη γέννηση",
      maximumKg: "Ανώτατο όριο",
      minimumKg: "Ελάχιστο",
      aSeasonisAPeriodOfYear: "Εποχή είναι μια περίοδος του έτους που διακρίνεται από ειδικές κλιματικές συνθήκες.",
      seasonofBirthIsRequired: "Απαιτείται περίοδος γέννησης",
      majorGenericContributionOfAnimal: "Σημαντική % Γενική Συνεισφορά Ζώου",
      primaryBreedCompostionIsRequired: "Απαιτείται Πρωτογενής Σύνθεση Φυλής",
      secondaryBreedCompostionIsRequired: "Απαιτείται δευτερεύουσα σύνθεση φυλής",
      howTheAnimalWasConceived: "Πώς συνελήφθη το ζώο (φυσικό ζευγάρωμα/γονιμοποίηση/εμβρυομεταφορά)",
      conceptionMethodIsRequired: "Απαιτείται μέθοδος σύλληψης",
      epdModelSettings: "Ρυθμίσεις μοντέλου EPD",
      forResetMode: "Για τη λειτουργία επαναφοράς",
      progenyWeightingFactor: "Παράγοντας βαρύτητας απογόνων",
      weightGivenToTheProgenyFactor: "Βάρος που δίνεται στον παράγοντα απογόνων σε σχέση με τον παράγοντα CG για τον υπολογισμό της EPD στη λειτουργία Επαναφοράς. ",
      enterNumber: "Εισάγετε αριθμό",
      enterBreed: "Εισάγετε Φυλή",
      valueShouldBeBetween0and1: "Η τιμή πρέπει να είναι μεταξύ 0 και 1",
      resetDuration: "Επαναφορά διάρκειας",
      timeIntervalBetweenLastAndFirstResetMode: "Χρονικό διάστημα μεταξύ της τελευταίας και της νέας λειτουργίας επαναφοράς, στο τέλος του οποίου ενεργοποιείται η νέα λειτουργία επαναφοράς και υπολογίζονται νέα CG και EPD.",
      enterNumberOfDays: "Εισαγάγετε τον αριθμό των ημερών",
      valueCannotBeNegative: "Η τιμή δεν μπορεί να είναι αρνητική!",
      criticalProgenyPopulation: "Κρίσιμος πληθυσμός απογόνων",
      minimumNumberOfProgenyRecords: "Ελάχιστος αριθμός εγγραφών απογόνων του μεμονωμένου ζώου στο σύστημα που είναι απαραίτητος για την επίτευξη Ακρίβειας Απογόνων (APD1) άνω του 50% (για ακρίβεια γενεαλογίας)",
      criticalAncestorPopulation: "Κρίσιμος πληθυσμός προγόνων",
      minimumNumberOfAncestorsRecords: "Ελάχιστος αριθμός εγγραφών προγόνων του μεμονωμένου ζώου στο σύστημα που είναι απαραίτητος για την επίτευξη Ακρίβειας Προγόνων (APD4) άνω του 50% (για ακρίβεια γενεαλογίας)",
      forBirthWeightCG: "Για CG βάρους γέννησης",
      criticalPopulationInAnimalsContemporaryGroup: "Critical Population In Animal's Contemporary Group",
      minimumAverageNumberOfAnimalsPerBirthWeight: "Ελάχιστος μέσος αριθμός ζώων ανά βάρος γέννησης CG απαραίτητος για την επίτευξη Μέσης Ακρίβειας CG (ACG3) πάνω από 50%",
      criticalAveragePopulationPerContemporaryGroup: "Κρίσιμος μέσος πληθυσμός ανά σύγχρονη ομάδα",
      minimumNumberOfAnimalsInBirthWeight: "Ελάχιστος αριθμός ζώων στο βάρος γέννησης CG του ζώου που είναι απαραίτητος για την επίτευξη Ακρίβειας CG (ACG2) πάνω από 50%",
      forWeaningWeightCG: "Για τον απογαλακτισμό CG",
      minimumAverageNumberOfAnimalsPerWeaningWeight: "Ελάχιστος μέσος αριθμός ζώων ανά βάρος απογαλακτισμού CG που είναι απαραίτητος για την επίτευξη μέσης ακρίβειας CG (ACG3) πάνω από 50%",
      minimumNumberOfAnimalsInWeaningWeight: "Ελάχιστος αριθμός ζώων στο βάρος απογαλακτισμού CG του ζώου που είναι απαραίτητος για την επίτευξη Ακρίβειας CG (ACG2) πάνω από 50%",
      forYearlingWeightCG: "Για ετήσιο βάρος CG",
      minimumAverageNumberOfAnimalsPerYearling: "Ελάχιστος μέσος αριθμός ζώων ανά έτος CG που είναι απαραίτητος για να επιτευχθεί Μέση Ακρίβεια CG (ACG3) πάνω από 50%",
      minimumNumberOfAnimalsInYearlingWeight: "Ελάχιστος αριθμός ζώων στο ετήσιο βάρος CG του ζώου που είναι απαραίτητος για την επίτευξη Ακρίβειας CG (ACG2) άνω του 50%",
      forCarcassCG: "Για το Carcas CG",
      minimumAverageNumberOfAnimalsPerCarcassWeight: "Ελάχιστος μέσος αριθμός ζώων ανά βάρος σφαγίου CG απαραίτητος για την επίτευξη μέσης ακρίβειας CG (ACG3) άνω του 50%",
      minimumNumberOFAnimalInCarcassWeight: "Ελάχιστος αριθμός ζώων στο βάρος του σφαγίου CG του ζώου που είναι απαραίτητος για την επίτευξη Ακρίβειας CG (ACG2) άνω του 50%",
      epdRequiredFieldSettings: "Απαιτούμενες ρυθμίσεις πεδίου EPD",
      pleaseSelectRequiredFieldsForCompleteEPD: "Επιλέξτε τα απαιτούμενα πεδία για έναν πλήρη υπολογισμό EPD",
      byDefault: "Από προεπιλογή",
      pleaseNoteThatUsersNotAbleToObtainFullEPD: "Σημείωση: Λάβετε υπόψη ότι οι χρήστες δεν θα μπορούν να λάβουν πλήρη υπολογισμό EPD εάν δεν παρέχουν τα πεδία δεδομένων που επισημαίνετε ως απαιτούμενα.",
      pleaseNoteThatRequiredFieldParametersCannotBeChanged: "Σημείωση: Λάβετε υπόψη ότι οι απαιτούμενες παράμετροι πεδίου δεν μπορούν να αλλάξουν, καθώς υπάρχουν ήδη σύγχρονες ομάδες σε σχέση με προηγούμενες παραμέτρους.",
      noResultFound: "ΔΕΝ ΒΡΕΘΗΚΕ ΑΠΟΤΕΛΕΣΜΑ",
      next: "Επόμενο",
      cancel: "Ματαίωση",
      selectAnimal: "Επιλέξτε Ζώο",
      searchBy: "Αναζήτηση κατά",
      breed: "Ράτσα",
      regDate: "Καν. ",
      status: "Κατάσταση",
      animalDetails: "Στοιχεία Ζώου",
      add: "Προσθήκη",
      update: "Εκσυγχρονίζω",
      dataForEPDs: " Δεδομένα για EPD",
      basicInformation: "Βασικές πληροφορίες",
      birthWeightInformation: "Πληροφορίες για το βάρος γέννησης",
      weaningWeightInformation: "Πληροφορίες για το βάρος απογαλακτισμού",
      yearlingWeightInformation: "Πληροφορίες για το βάρος του έτους",
      carcassWeightInformation: "Πληροφορίες για το βάρος του σφαγίου",
      delete: "Διαγράφω",
      deleteEpdData: "Διαγραφή δεδομένων EPD",
      areYouSureYouWantToDeleteEpdData: "Είστε βέβαιοι ότι θέλετε να διαγράψετε δεδομένα EPD.",
      internationalID: "Διεθνής ταυτότητα",
      enterID: "Εισαγάγετε αναγνωριστικό",
      animalRegistration: "Εγγραφή Ζώων",
      location: "Τοποθεσία",
      additionalIDMethod: "Μέθοδος πρόσθετης ταυτότητας",
      damID: "Ταυτότητα φράγματος",
      sireID: "Ταυτότητα κυρίου",
      breederHerdCode: "Κώδικας αγέλης κτηνοτρόφων",
      birthYear: "έτος γέννησης",
      primaryBreed: "Πρωτογενής Φυλή",
      breedComposition: "Σύνθεση φυλής",
      secondaryBreed: "Δευτερογενής Φυλή",
      seasonofBirth: "Εποχή Γέννησης",
      birthManagementCode: "Κώδικας διαχείρισης γεννήσεων",
      damAge: "Βλάβη",
      years: "Χρόνια",
      birthContemporaryCode: "Γέννηση Σύγχρονος Κώδικας",
      accuracyWeight: "Ακρίβεια Βάρος",
      note: "Σημείωση",
      minimumRequiredFieldForBirthWeight: "Ελάχιστο απαιτούμενο πεδίο για EPD βάρους γέννησης",
      birthYearGenderConceptionMethodBirthWeight: "Έτος γέννησης , Φύλο , Τρόπος σύλληψης , Βάρος γέννησης",
      weaningWeight: "Βάρος απογαλακτισμού",
      weaningDate: "Ημερομηνία Απογαλακτισμού",
      weaningContemporaryGroupCode: "Weaning Contemporary Group Code",
      creep: "Ανατριχιάζω",
      managementPastureCode: "Κώδικας Διαχείρισης/Βοσκότοπων",
      weaningSex: "Σεξ απογαλακτισμού",
      minimumRequiredFieldForWeaningWeight: "Ελάχιστο απαιτούμενο πεδίο για EPD Βάρος Απογαλακτισμού",
      weaningWeightManagementPastureCodeWeaningSexDateWeighed: "Βάρος Απογαλακτισμού , Κωδικός Διαχείρισης/Βοσκότοπων , Φύλο Απογαλακτισμού , Ημερομηνία ζύγισης",
      yearlingWeight: "Ετήσιο Βάρος",
      yearlingHeight: "Ύψος ενός έτους",
      yearlingDate: "Ημερομηνία ετήσιας",
      yearlingContemporaryGroupCode: "Yearling Contemporary Group Code",
      managementFeedingCode: "Κώδικας Διαχείρισης/Σίτισης",
      yearlingSex: "Ετήσιο σεξ",
      youWillNeedToFillOutFor: "Θα χρειαστεί να συμπληρώσετε όλα τα πεδία για να ανακτήσετε δεδομένα EPD",
      pleaseSelectHavestDateFirstToEnterInfo: "Επιλέξτε \"Ημερομηνία Συγκομιδής\" πρώτα για να εισαγάγετε πληροφορίες για την περιοχή των ματιών, το πάχος λίπους και το μαρμάρισμα ",
      harvestDate: "Ημερομηνία Συγκομιδής",
      dateOnFeed: "Ημερομηνία Τροφοδοσίας",
      daysOnFeed: "Days On Feed",
      gradingDate: "Ημερομηνία βαθμολόγησης",
      carcassSex: "Σεξ με σφάγιο",
      carcassWeight: "Βάρος σφαγίου",
      carcassContemporary: "Carcas Contemporary",
      damBreed: "Dam Breed",
      ribEyeArea: "Περιοχή ματιών πλευρών",
      ribEyeAreaContemporary: "Rib Eye Area Contemporary",
      fatThickness: "Πάχος λίπους",
      fatThicknessContemporary: "Σύγχρονο πάχος λίπους",
      marbling: "Μαρμαροποίηση",
      marblingContemporary: "Marbling Contemporary",
      yieldGradeContemporary: "Βαθμός απόδοσης Σύγχρονο",
      animalsNotListedInContemporaryGroupsMsg: "Τα ζώα δεν έχουν προστεθεί σε καμία σύγχρονη ομάδα λόγω έλλειψης πληροφοριών. ",
      listOfUngroupedAnimals: "Κατάλογος μη ομαδοποιημένων ζώων",
      submittingData: "Υποβολή Δεδομένων",
      resendToUser: "Εκ νέου αποστολή σε χρήστη",
      submittingAnimalsInGroupMsg: "Υποβάλλετε τα ζώα σας σε ομάδες. ",
      pressingResetBtnMsg: "Πατώντας το κουμπί \"Επαναφορά\" θα ξεκινήσει μια διαδικασία εκ νέου ανάθεσης ζώων στις σύγχρονες ομάδες τους. ",
      doYouWantToProceed: "Θέλετε να συνεχίσετε ?",
      systemMaintainanceModeMsg: "Πατώντας το κουμπί \"Αλλαγή σε λειτουργία συντήρησης\" θα ξεκινήσει μια διαδικασία και το σύστημά σας θα εισέλθει στη \"ΛΕΙΤΟΥΡΓΙΑ ΣΥΝΤΗΡΗΣΗΣ\" όπου τα EDP που υπολογίζονται στο RESET θα διατηρηθούν σταθερά για κάθε ζώο μέχρι το επόμενο RESET (που μπορεί να είναι 1-6 μήνες ",
      errorFetchingContemporaryGrpMsg: "Σφάλμα κατά την ανάκτηση των σύγχρονων δεδομένων ομάδας",
      deleteSuccess: "Διαγραφή επιτυχίας",
      deleteSuccessMsg: "Η σύγχρονη ομάδα διαγράφηκε με επιτυχία.",
      deleteFailed: "Η διαγραφή απέτυχε",
      deleteFailedMsg: "Σφάλμα κατά τη διαγραφή των σύγχρονων δεδομένων ομάδας",
      deleteContemporaryGrpMsg: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν τη σύγχρονη ομάδα;",
      addBirthWeightData: "Προσθέστε δεδομένα βάρους γέννησης",
      addWeaningWeightData: "Προσθέστε δεδομένα βάρους απογαλακτισμού",
      birthWeightContemporaryGroupCode: "Βάρος γέννησης Contemporary Group Code",
      dateWeighted: "Ημερομηνία στάθμισης",
      addYearlingWeightData: "Προσθέστε στοιχεία για το ετήσιο βάρος",
      addCarcassWeightData: "Προσθέστε δεδομένα βάρους σφαγίου",
      weaningOrYearlingContemporaryGroupCode: "Weaning or Yearling Weight Contemporary Group Code",
      deleteContemporaryGroupMsg: "Είστε βέβαιοι ότι θέλετε να διαγράψετε τη σύγχρονη ομάδα;",
      updateSuccessMsg: "Η σύγχρονη ομάδα ενημερώθηκε με επιτυχία.",
      errorMsg: "Κάτι πήγε στραβά. ",
      fetchErrorMsg: "Σφάλμα κατά την ανάκτηση των απαιτούμενων πεδίων για το επιλεγμένο χαρακτηριστικό.",
      forMaintainanceMode: "Για τη λειτουργία συντήρησης",
      ancestorsWeightFactor: "Παράγοντας βάρους προγόνων",
      weightGivenToTheAncestorFactor: "Βάρος που δίνεται στον παράγοντα πρόγονο σε σχέση με τον παράγοντα CG για τον υπολογισμό EPD στη λειτουργία Maintenance. ",
      addEPDModelSettingsData: "Προσθήκη δεδομένων ρυθμίσεων μοντέλου EPD",
      minimumNumberOfAnimalsInContemporaryGroups: "Ελάχιστος αριθμός ζώων σε σύγχρονες ομάδες",
      enterNumberOfAnimals: "Εισαγάγετε τον αριθμό των ζώων",
      areYouSureYouWantToChangeEPDCalculation: "Είστε βέβαιοι ότι θέλετε να αλλάξετε τα απαιτούμενα πεδία υπολογισμών EPD;",
      weightOfAnimalAtBirth: "Βάρος ζώου κατά τη γέννηση",
      seasonIsAPeriodOfYear: "Εποχή είναι μια περίοδος του έτους που διακρίνεται από ιδιαίτερες κλιματικές συνθήκες.",
      codeOfBirthWeightContemporaryGroup: "Code of the Birth Weight Contemporary Group",
      weaningWeightOfCalf: "Βάρος Απογαλακτισμού Μοσχαριού",
      dateAnimalWasWeaned: "Η ημερομηνία απογαλακτισμού του ζώου",
      genderOfWeaningAnimal: "Φύλο Απογαλακτισμού Ζώου",
      yearlingWeightOfCalf: "Ετήσιο Βάρος Μοσχαριού",
      dateAnimalWasWeighted: "Η ημερομηνία ζύγισης του ζώου",
      yearledAnimalSex: "Το φύλο του ζώου που ήταν χρόνια",
      dateOfAnimalKilledForMeat: "Ημερομηνία θανάτωσης ζώου για κρέας",
      addSuccessMsg: "Η σύγχρονη ομάδα προστέθηκε με επιτυχία",
      traitH: "Το χαρακτηριστικό για τον υπολογισμό της EPD.",
      searchByValue: "Εισαγάγετε τον αριθμό εγγραφής/Τατουάζ/Όνομα/Ετικέτα"
    }
  }